export const lang = {
    get: (string, parameters?) => {
        switch (string) {
            // Integrations + Fortnox (Z): MACHINE-TRANSLATED from Swedish, needs native-Norwegian review (language.dk-no.REVIEW.md)
            case 'INTEG_INTRO': return `Aktiver og administrer tillegg for ${parameters[0]}.`;
            case 'INTEG_CONNECTED_TO': return `Koblet til ${parameters[0]}`;
            case 'INTEG_CONNECTED_TO_AUTO': return `Koblet til ${parameters[0]} · automatisk eksport på`;
            case 'INTEG_STATUS_FAILED': return `Status kunne ikke hentes (${parameters[0]})`;
            case 'FZ_NOTICE_ORG_MISMATCH': return `Feil selskap: Fortnox-kontoen tilhører ${parameters[0]} (${parameters[1]}), men restauranten tilhører ${parameters[2]}. Ingenting ble lagret.`;
            case 'FZ_NOTICE_DENIED': return `Koblingen ble avbrutt i Fortnox: ${parameters[0]}`;
            case 'FZ_NOTICE_ERROR': return `Koblingen mislyktes: ${parameters[0]}`;
            case 'FZ_CONNECTED_META': return `koblet ${parameters[0]} av ${parameters[1]}`;
            case 'FZ_SCOPE_NOTE': return `Koblingen gjelder alle restauranter som tilhører ${parameters[0]}. Innstillingene nedenfor gjelder bare ${parameters[1]}.`;
            case 'FZ_ORG_MISMATCH_WARN': return `Restaurantens selskap i PubQ har org.nr. ${parameters[0]}, men er koblet til ${parameters[1]}.`;
            case 'FZ_REAUTH_WARN': return `Fortnox-koblingen for ${parameters[0]} har utløpt og må godkjennes på nytt.`;
            case 'FZ_ALREADY_CONNECTED': return `Selskapet ${parameters[0]} er allerede koblet til – restauranten er nå tilknyttet.`;
            case 'FZ_SETTINGS_FOR': return `Innstillinger for ${parameters[0]}`;
            case 'FZ_FROM_Z': return `fra Z ${parameters[0]}`;
            case 'FZ_EG': return `f.eks. ${parameters[0]}`;
            case 'FZ_APPROVED_SO_FAR': return `${parameters[0]} bokført hittil`;
            case 'FZ_PREVIEW_TITLE': return `Bilag for Z ${parameters[0]}`;
            case 'FZ_SERIES_X': return `serie ${parameters[0]}`;
            case 'FZ_PREVIEW_SUMMARY': return `${parameters[0]} kvitteringer · Z-rapportens total ${parameters[1]} kr`;
            case 'FZ_DROPPED': return `${parameters[0]} nullinje(r) utelatt`;
            case 'FZ_RESEND_TITLE': return `Sende Z ${parameters[0]} på nytt?`;
            case 'FZ_RESEND_ALREADY': return `Z ${parameters[0]} er allerede bokført.`;
            case 'FZ_RESEND_ALREADY_AS': return `Z ${parameters[0]} er allerede bokført som ${parameters[1]}.`;
            case 'FZ_DISCONNECT_ALL': return `Dette kobler fra Fortnox for alle restauranter som tilhører ${parameters[0]}.`;
            case 'FZ_TOAST_SENT': return `Z ${parameters[0]} bokført`;
            case 'FZ_TOAST_SENT_AS': return `Z ${parameters[0]} bokført som ${parameters[1]}`;
            case 'FZ_TOAST_NOT_SENT': return `Z ${parameters[0]} ble ikke sendt`;
            case 'FZ_BACKFILL_RESULT': return `Ettersendt: ${parameters[0]} bokført, ${parameters[1]} ikke`;
            case 'FZ_BACKFILL_STOPPED': return `Stoppet ved Z ${parameters[0]}: ${parameters[1]}`;
            case 'FZ_ERR_SECTION_TIMEOUT': return `Fortnox-tjenesten svarte ikke innen ${parameters[0]} s`;
            case 'FZ_ERR_SIGNIN_TIMEOUT': return `Innloggingen svarte ikke innen ${parameters[0]} s`;
            case 'FZ_CUST_REFRESHED': return `Oppdatert fra Fortnox: ${parameters[0]} felt endret.`;
            case 'CARD_ADDED_FOR': return `'Kort lagt til ${parameters[0]}`;
            case 'REMOVE_NAME': return `'Slette ${parameters[0]}?`;
            case 'REMOVED_IMAGE': return `'Fjernet ${parameters[0]}`;
            case 'PRODUCTS_UPDATED': return `'${parameters[0]}-produkter oppdatert`;
            case 'UPDATING_PRODUCTS_PROGRESS': return `Oppdaterer produkter ${parameters[0]} av ${parameters[1]}`;
            case 'SAVING_MENU': return `'Lagrer menyen for ${parameters[0]}`;
            case 'REMOVE_MENU': return `'Slette ${parameters[0]}?`;
            case 'SAVING_GALLERY': return `'Lagrer i bilder for ${parameters[0]}`;
            case 'REMOVED_IMAGE': return `'Fjernet ${parameters[0]}`;
            case 'NUMBER_ARTICLES': return `'${parameters[0]} artikler`;
            case 'UPDATE_ITEM': return `'Oppdatert ${parameters[0]}`;
            case 'PRODUCT_ADDED': return `'${parameters[0]} lagt til`;
            case 'PRODUCT_REMOVED': return `'${parameters[0]} fjernet`;
            case 'REMOVE_PRODUCT_CATEGORY': return `'Vil du slette ${parameters[0]}?`;
            case 'REMOVE_BONG_CATEGORY': return `'Vil du slette ${parameters[0]}?`;
            case 'SHARE_NEWS_WITH': return `'Deler nyhetene med ${parameters[0]}`;
            case 'NEWS_SHARED': return `'Delt ${parameters[0]}`;
            case 'TIMELINE_SAVED_FOR': return `'Lagrer tidslinjen for ${parameters[0]}`;
            case 'SHARING_OFFER_WITH': return `'Deler tilbudet med ${parameters[0]}`;
            case 'OFFER_SHARED': return `'Delt ${parameters[0]}`;
            case 'REMOVE_COUPON': return `'Slette ${parameters[0]}?`;
            case 'LINKED_PRODUCT': return `'Koblet ${parameters[0]}`;
            case 'COPY_FROM': return `'Kopier fra ${parameters[0]}?`;
            case 'REMOVE': return `'Slette ${parameters[0]}?`;
            case 'REMOVE_CORPORATE_USER_QUESTION': return `Er du sikker på at du vil fjerne ${parameters[0]}?`;
            case 'REMOVING': return `'Slette ${parameters[0]}?`;
            case 'ADDED': return `'Lagt til ${parameters[0]}`;
            case 'PRODUCT_SAVED': return `'${parameters[0]} ble reddet`;
            case 'SAVING_PRODUCT': return `'Lagrer produkt for ${parameters[0]}`;
            case 'CONFIRM_REMOVE_ACCOUNTING': return `'Er du sikker på at du vil slette ${parameters[0]}?`;
            case 'REMOVE_ACCOUNTING': return `'${parameters[0]} fjernet`;
            case 'SAVED': return `'Lagret ${parameters[0]}`;
            default: return '';
        }
    },
    AMOUNT_MIN_MOBILE_WALLET: 'Minimumsbeløpet',
    AMOUNT_1_MOBILE_WALLET: 'Beløp 1',
    AMOUNT_2_MOBILE_WALLET: 'Beløp 2',
    CHOSE_PRINTER: 'Velg skriver',
    SAVE_AS_PDF: 'Lagre som PDF',
    MY_ACCOUNT: 'Min konto',
    USER_ID: 'BrukerID',

    PROFILE: 'Profil',
    ADD_INFO_TO_PROFILE: 'Legg til informasjon i profilen din slik at vi bedre kan støtte deg på denne reisen.',
    PLEASE_ENTER_ADDRESS: 'Vennligst skriv inn adressen din',
    FIRST_NAME: 'Fornavn',
    LAST_NAME: 'Etternavn',
    POSTCODE: 'postnummer',
    COUNTRY: 'Land',
    NEXT_STEP: 'Neste steg',

    ORGANIZATION: 'Organisasjon',
    ENTER_ORG_INFO: 'Skriv inn organisasjonsinformasjonen din.',
    ENTER_COMPANY_NAME: 'Vennligst skriv inn et firmanavn',
    VALIDATE: 'VALIDERE',
    VALIDATING: 'VALIDERING',
    VALIDATED: 'VALIDERT',
    PREVIOUS: 'Forrige',

    REVIEW_DETAILS_SUBMIT: 'Se gjennom detaljene dine og send inn',
    WIZARD3_TEXT1: 'Nå er vi nesten gjennom registreringsdelen, dobbeltsjekk informasjonen din nedenfor.',
    WIZARD3_TEXT2: 'Deretter kan du begynne å utforske PubQ-plattformen.',
    WIZARD3_TEXT3: 'Et nytt selskap vil bli opprettet med navnet',

    FREE_REGISTER: 'Gratis registrering for å komme i gang',
    STEP: 'Steg',

    SIGNUP: 'Melde deg på',
    CREATE_ACC_DETAILS: 'Skriv inn detaljene dine for å opprette kontoen din',
    FULLNAME: 'Fullt navn',
    IS_REQUIRED: 'er nødvendig',
    CONFIRM_PASSWORD: 'bekreft passord',
    REGISTER: 'Registrere',
    LOG_OUT: 'Logg ut',
    HANDLE_PERSONNELCARD: 'Administrer personalkort',
    CREATE_NEW_CARD: 'Lag et nytt kort',
    PERSONNELCARD: 'Personalkort',
    NAME: 'Navn',
    NAME_REQUIRED: 'Navn er påkrevd.',
    TEXT_ON_CARD: 'Tekst på kort',
    AVAILABLE_THROUGH: 'Gyldig til',
    URL_TO_BACKGROUND: 'Bakgrunns-URL',
    REMOVE: 'Ta vekk',
    SAVE: 'Lagre',
    SEARCH: 'Søk',
    SEARCH_IMAGE: 'Søk bilde...',
    SEARCH_VIDEO: 'Søk video...',
    BACK: 'Tilbake',
    UNIT_SWITCHER_SEARCH_UNITS: 'Søk enheter etter navn eller ID',
    UNIT_SWITCHER_SELECT: 'for å velge',
    UNIT_SWITCHER_OPEN: 'for å åpne',
    UNIT_SWITCHER_CLOSE: 'for å lukke',
    UNIT_SWITCHER_NO_RESULTS: 'Ingen enheter funnet',
    USER_WITH_CARD: 'Brukere med kort',
    ID: 'Id',
    CARD: 'Kort',
    JANUARY: 'Januar',
    FEBRUARY: 'Februar',
    MARS: 'Mars',
    APRIL: 'April',
    MAY: 'Mai',
    JUNE: 'Juni',
    JULY: 'Juli',
    AUGUST: 'August',
    SEPTEMBER: 'September',
    OCTOBER: 'Oktober',
    NOVEMBER: 'November',
    DECEMBER: 'Desember',
    JAN3: 'Jan',
    FEB3: 'Feb',
    MAR3: 'Mar',
    APR3: 'Apr',
    MAY3: 'Mai',
    JUN3: 'Jun',
    JUL3: 'Jul',
    AUG3: 'Aug',
    SEP3: 'Sep',
    OCT3: 'Okt',
    NOV3: 'Nov',
    DEC3: 'Des',
    OK: 'OK',
    AUTHORIZED_USERS: 'Autoriserte brukere',
    ADD_NEW_USER: 'Legg til ny bruker',
    NO_AUTHORIZED_USERS: 'Ingen autoriserte brukere ennå.',
    ENTER_USER_NAME: 'Skriv inn brukernavn',
    ENTER_USER_EMAIL: 'Skriv inn brukerens e-post',
    CORPORATE_USER_INVITED: 'Autorisert bruker invitert.',
    RESEND_INVITATION: 'Send invitasjon på nytt',
    CORPORATE_USER_INVITATION_RESENT: 'Invitasjonen ble sendt på nytt.',
    CORPORATE_USER_INVITATION_RESEND_FAILED: 'Kunne ikke sende invitasjonen på nytt.',
    CORPORATE_USER_ALREADY_LINKED: 'Denne brukeren er allerede koblet til denne bedriften for denne lokasjonen.',
    CORPORATE_USER_REMOVED: 'Autorisert bruker fjernet.',
    CORPORATE_USER_REMOVE_FAILED: 'Kunne ikke fjerne autorisert bruker.',
    FAILED_TO_LOAD_AUTHORIZED_USERS: 'Kunne ikke laste autoriserte brukere.',

    USERNAME: 'BRUKERNAVN',
    DATE: 'DATO',
    ORDER_NAME: 'BESTILLINGSNAVN',
    TOTAL_ITEMS: 'TOTALT ARTIKLER',
    CITY: 'BY',
    ADDRESS: 'Adresse',
    ACTIONS: 'HANDLINGER',
    PLACE_ORDER: 'Legg inn bestilling',
    CANCEL: 'Avbryt',
    SCHEDULE_VIEW: 'Tidsplan',
    SORTED_ON_PRODUCT: 'Sortert etter produkt',
    DAY: 'Dag',
    TOTAL: 'Totalt',
    ORDERS_TODAY: 'Bestillinger i dag',
    ORDERS_THIS_MONTH: 'Bestillinger denne måneden',
    ACTIVITY: 'Aktivitet',
    COUPONS_IN_APP: 'Kuponger brukt i appen',
    PER_PRODUCT: 'Pr. produkt',
    USERS_WITH_CODES: 'Brukere med rabattkoder',
    RECEIPTNO: 'Kvitteringsnr',
    TIME: 'Tid',
    CODE: 'Kode',
    ORDERCODE: 'Bestillingskode',
    NAVIGATE_HERE: 'Naviger hit eller bruk menyen øverst til venstre',
    UPLOADING: 'Laster opp',
    UPLOAD: 'Laste opp...',
    GALLERY: 'Bilder',
    GALLERY_IMAGE_LOAD_FAILED: 'Bildet kunne ikke lastes inn',
    GALLERY_RETRY: 'Prøv igjen',
    GALLERY_SHOW_MORE: 'Vis flere',
    GALLERY_IMAGE_REMOVED: 'Bildet ble fjernet',
    GALLERY_VIDEO_REMOVED: 'Videoen ble fjernet',
    DELETE_IMAGE: 'Slett bilde',
    ARE_YOU_SURE_GALLERY: 'Er du sikker på at du vil fjerne bildet fra galleriet?',
    ARE_YOU_SURE: 'Er du sikker?',
    UPDATING_IMAGE_QUICK: 'Vent ... vi oppdaterer bildet ditt snart',
    SYNC_PRODUCTS: 'Synkroniser produkter',
    CLEAR_EXISTING_PROUCTS: 'Fjern eksisterende produkter?',
    UPDATING_PRODUCTS: 'Oppdaterer produkter',
    SAVING_OPTION_GROUP: 'Lagrer tilleggsgruppe…',
    OPT_GROUP_SAVE_FAILED: 'Kunne ikke lagre tilleggsgruppen.',
    PRODUCT_PAGE_VERIFY: 'Gå til produktsiden for å bekrefte',
    FROM: 'Fra',
    TO: 'Til',
    ORDERVALUE_COUPON: 'Bestillingsverdi med  rabattkode',
    SUM_RECEPITS_COUPON: 'Summen av kvitteringer der gjesten handlet med en rabattkode',
    CODE_CAPS: 'KODE',
    DISCOUNT_CAPS: 'RABATT',
    NETTO_CAPS: 'NETTO',
    VAT_CAPS: 'MVA',
    TOTAL_CAPS: 'TOTALT',
    TODAY_CAPS: 'I DAG',
    CLOSE_CAPS: 'STENG',
    RESET_FORTNOX: 'Gjenopprette Fortnox-tilkoblingen?',
    RESET_FORTNOX_TEXT: 'Er du sikker på at du vil fjerne Fortnox-kontakten og gjenopprette den slik at en ny kontakt kan opprettes?',
    NO: 'Nei',
    YES: 'Ja',
    AUTHORIZATIONCODE: 'Godkjennelseskoden',
    AUTHORIZED: 'GODKJENT',
    VOUCHER_SERIES: 'Verifiserings',
    ROUNDING_ACCOUNT: 'Konto for øreavrunding',
    ACTIVATE: 'Aktiver',
    INTEGRATIONS: 'integrasjoner',
    PASSWORD: 'Passord',
    FORWARD: 'Videre',
    FORGOT_PASSWORD: 'Glemt passord?',
    RESET_EMAIL_HEAD: 'E-post for tilbakestilling',
    RESET_EMAIL_TXT: 'Fyll ut e-postadressen din',
    NEW_MENU: 'Ny meny',
    COPY: 'kopiere',
    SURE: 'Er du sikker?',
    MENU_SHARED: 'Delt meny!',
    SOMETHING_WRONG: 'Noe gikk galt!',
    ACTIVATE_BEFORE_REMOVE: 'Du må aktivere en annen meny før du kan slette denne',
    REMOVE_FOR_ALL: 'Vil du slette for alle?',
    REMOVE_EVEN_OTHERS: 'Vil du også slette innlegget hvis det finnes på andre restauranter?',
    REMOVED_FROM_ALL: 'Fjernet fra alle restauranter',
    MONDAY: 'Mandag',
    TUESDAY: 'Tirsdag',
    WEDNESDAY: 'Onsdag',
    THURSDAY: 'Torsdag',
    FRIDAY: 'Fredag',
    SATURDAY: 'Lørdag',
    SUNDAY: 'Søndag',
    FAILED: 'Misslykkes',
    ERROR: 'Feil',
    SAVED: 'Lagret!',
    MENUS: 'Menyer',
    VISIBLE_IN_APP: 'Synlig i appen',
    WEEKLY_MENU: 'Ukentlig meny',
    WEEKLY_MENU_PLANNER: 'Planlegger for ukemeny',
    WEEKLY_MENU_PLANNER_DESCRIPTION: 'Bygg en ukentlig produktplan fra mandag til søndag.',
    GLOBAL_SETTINGS: 'Forhåndsbestillingsgrenser',
    WEEKLY_MENU_GLOBAL_SETTINGS_DESCRIPTION: 'Velg hvor mange dager i forveien gjester kan bestille.',
    ORDER_DAYS_IN_ADVANCE: 'Kunder kan bestille så mange dager i forveien',
    DAY_SETTINGS: 'Dagsinnstillinger',
    SEARCH_PRODUCTS: 'Søk produkter',
    SEARCH_PRODUCT_REGISTER: 'Søk i produktregisteret',
    WEEKLY_MENU_PRODUCT: 'Ukentlig meny-produkt',
    WEEKLY_MENU_PRODUCT_HINT: 'Vis denne produkten i produktregisteret for ukentlig meny.',
    WEEKLY_MENU_PRICE_HELP: 'Valgfritt: la feltet stå tomt for å bruke grunnpris for den serveringsmetoden.',
    WEEKLY_MENU_AVAILABLE_THIS_DAY: 'Tilgjengelig denne dagen',
    WEEKLY_MENU_PRODUCT_ENABLED_EVERYWHERE_HINT: 'Når av, skjules produktet overalt det brukes, ikke bare denne ukedagen.',
    PRICE_OPTIONS: 'Prisalternativer',
    EAT_IN_PRICE: 'Pris spise her',
    TAKEAWAY_PRICE: 'Takeaway-pris',
    SHOW_IN_DRIVEDELIVERY: 'Vis for kjørelevering',
    SHOW_IN_FIXEDLOCATION: 'Vis for fast lokasjon',
    CLOSED_FOR_ORDERING: 'Stengt for bestilling',
    OPEN_FOR_ORDERING: 'Åpen for bestilling',
    SERVING_OPTIONS: 'Serveringsmetoder',
    SERVING_OPTIONS_DESCRIPTION: 'Velg hvilke serveringsmetoder som skal være tilgjengelige i salgskanalene',
    ENABLE_SERVING_METHOD: 'Administrer serveringsmetoder',
    ENABLE_SERVING_METHOD_DESCRIPTION: 'Når en serveringsmetode er aktivert, kan gjester i salgskanalene velge den ved bestilling.',
    SERVING_OPTIONS_MENU: 'Velg serveringsmetoder for ukemeny',
    SERVING_OPTIONS_MENU_EXPLANATION: 'Aktiver disse serveringsmetodene når ukemenyen er aktiv',
    SERVING_OPTIONS_SAVED: 'Serveringsinnstillinger lagret',
    EAT_IN: 'Spis her',
    DELIVERY_TO_FIXED_LOCATIONS: 'Levering til fast sted',
    EDIT_LOCATIONS: 'Rediger lokasjoner',
    DELIVERY_LOCATIONS: 'Leveringslokasjoner',
    NEW_DELIVERY_LOCATION: 'Ny leveringslokasjon',
    MINIMUM_FEE_OPTIONAL: 'Minimumsavgift (valgfritt)',
    NO_LOCATIONS_ADDED: 'Ingen lokasjoner lagt til ennå',
    ORDER_CUTOFF_TIME: 'Bestillingsfrist',
    AVAILABLE_FROM: 'Tilgjengelig fra',
    AVAILABLE_UNTIL: 'Tilgjengelig til',
    ORDERS_MUST_BE_PLACED_BEFORE_THIS_TIME: 'Bestillinger må legges inn før dette tidspunktet.',
    SAVE_SETTINGS: 'Lagre innstillinger',
    GLOBAL_SETTINGS_SAVED: 'Globale innstillinger lagret',
    SETTINGS_SAVED: 'Innstillinger lagret',
    SHOW_BUTTON: 'Vis ukemeny på appens startside. Oppdater teksten ukentlig slik at brukerne kan se menyen',
    UPLOAD_PROGRESS: 'Laster opp',
    GALLERY_SHARED: 'Dele bilder!',
    USE_IMAGE: 'Bruk bilde',
    USE_VIDEO: 'Bruk video',
    PREVIEW_VIDEO: 'Forhåndsvis video',
    DELETE_VIDEO: 'Slett video',
    UPDATING_IMAGE: 'Vent ... vi oppdaterer bildet ditt snart',
    COMPRESSING: 'Komprimerer',
    HELP: 'Hjelp',
    IN_STOCK: 'På lager',
    OUT_OF_STOCK: 'Utsolgt',
    STOCK_BALANCE_ERROR: 'Lagerstatus må være større enn 0',
    FEW_LEFT_IN_STOCK: 'Få igjen på lager',
    CATEGORIES: 'Kategorier',
    FOOD: 'Mat',
    ALL: 'Allt',
    DRINKS: 'Dryck',
    PRODUCTS: 'Produkter',
    ADD: 'Legge til',
    UPDATE: 'Oppdater',
    CONFIRM: 'Ok',
    PRODUCT_CATEGORIES: 'Produkt kategorier',
    BONG_CATEGORIES: 'Bong-kategorier',
    NEW_PRODUCT_CATEGORY: 'Ny produktkategori',
    REMOVE_PRODUCT_CATEGORY: 'Slett produktkategori!',
    EDIT_PRODUCT_CATEGORY: 'Endre produktkategori',
    NEW_BONG_CATEGORY: 'Ny Bong-kategori',
    REMOVE_BONG_CATEGORY: 'Fjern bongkategori!',
    EDIT_BONG_CATEGORY: 'Endre Bong-kategori',
    COURSE: 'Rett',
    COURSE_NAME_1: 'Forrett',
    COURSE_NAME_2: 'Hovedrett',
    COURSE_NAME_3: 'Dessert',
    NO_COURSE: 'Ingen rett',
    NO_COURSE_DIRECT: 'Ingen rett (sendes med en gang)',
    COURSE_HINT: 'Kassen legger varer i denne bong-kategorien i valgt rett. Ingen rett: sendes til kjøkkenet med en gang.',
    TIMELINE: 'Tidslinje',
    NEW_POST: 'Nytt innlegg',
    SHARE: 'Dele',
    CHOOSE_IMAGE: 'Velg bilde ...',
    TITLE: 'Tittel',
    TEXT: 'Tekst',
    OFFER: 'Tilbud',
    PRODUCT: 'Produkt',
    URL: 'Url',
    STATIC: 'Statisk',
    APP_TAB: 'Kategorien i appen produktet ligger under',
    OFFER_INFO: 'Info om tilbud',
    WARNING: 'Advarsel',
    ALREADY_EDITING: 'Du redigerer allerede en annen oppføring. Er du sikker på at du vil lukke uten å lagre?',
    ABORT_Q: 'Avbryt?',
    CONFIRM_CHANGES: 'Er du sikker på at du vil avbryte? Endringer vil gå tapt',
    FILL_ALL_FIELDS: 'Du må fylle ut alle felt unntatt tittel og tekst',
    SAVE_NEWS: 'Lagrer nyheter',
    MAIN_TEXT: 'Hovedtekst',
    NEW_TITLE: 'Ny tittel',
    REMOVE_POST: 'Slette innlegg?',
    REMOVE_POST_CONFIRM: 'Er du sikker på at du vil slette innlegget?',
    REMOVE_FOR_OTHERS: 'Vil du også slette innlegget hvis det finnes på andre restauranter?',
    TIMELINE_SHARED: 'Delt tidslinje!',
    TYPE: 'Type',
    SERVING_METHOD: 'Serveringsmetode',
    APPLIES_FOR: 'Gjelder for',
    PRODUCT_TYPES: 'Produkttyper',
    DISCOUNT_PERCENTAGE: 'Prosentrabatt',
    AUTOMATIC_ACTIVATION: 'Aktiver automatisk for brukere',
    CREATING_OFFER: 'Oppretter tilbudet',
    OFFER_CREATED: 'Tilbud opprettet!',
    UPDATING_OFFER: 'Oppdaterer tilbudet',
    OFFER_UPDATED: 'Oppdaterte tilbudet',
    REMOVING: 'Fjern',
    OFFER_REMOVED: 'Fjernet tilbudet',
    NEW_BUTTON: 'Ny tast',
    CREATE_NEW_BUTTON: 'Opprett ny tast',
    CONNECT_BUTTON: 'Hva skal tasten kobles til?',
    CHOOSE_BG_IMAGE: 'Velg bakgrunn ...',
    BUTTON_LAYER: 'Tast gruppe',
    FREE_TEXT: 'Fri tekst',
    ACTIVATE_IN_POS: 'AKTIVER PÅ KASSEN',
    ALLERGY_INFO_SAVED: 'Allergiinfo lagret og synlig i appen',
    MINIMUM_BONUS_SAVED: 'Minimum bonus lagret',
    PAYMENT_OPTIONS_SAVED: 'Betalingsmåter lagret',
    DELIVERY_OPTIONS_SAVED: 'Visningsinnstillinger lagret',
    NOTIFICATION_SAVED: 'Merknad lagret',
    INSTAGRAM_SAVED: 'Instagram lagret',
    FACEBOOK_SAVED: 'Facebook lagret',
    MENU_STYLE_SAVED: 'Menyutseende lagret',
    FOOD_SETTINGS_SAVED: 'Matinnstillinger lagret',
    DRINK_SETTINGS_SAVED: 'Drikkeinnstillinger lagret',
    DISCOUNT_SETTINGS_SAVED: 'Rabattinnstillinger lagret',
    COUPON_NAME: 'Navnet på kupongen',
    PERCENTAGE_IN_DISOUNT: 'Antall prosent i rabatt',
    TAKEAWAY: 'Ta med',
    TABLE_SERVING: 'Bordservering',
    COLLECT_IN_BAR: 'Hentes i restauranten',
    DELIVERY: 'Kjører ut',
    SENDING_PUSH: 'Sender pushvasel',
    PUSH_SENT: 'Push varsel sendt!',
    GENERAL: 'Generelt',
    GENERATE_REPORT: 'Generer rapport',
    PUSH_NOTIFICATIONS: 'Pushvarsel',
    OFFERS: 'Tilbud',
    DELIVERY_OPTIONS: 'Serveringsalternativer',
    PAYMENT_OPTIONS: 'Betalingsalternativer',
    USE_SAVE_BUTTON: 'Endringer på denne siden påvirker mobilappen, og Lagre-knappene må brukes for at endringene skal tre i kraft',
    OPEN_FOR_SALE: 'Åpent for salg',
    MESSAGE_WHEN_CLOSED: 'Merknad til kunden når fanen er lukket',
    FOOD_TAB: 'Matfane',
    DRINK_TAB: 'Drikke fanen',
    NOTIFICATION_IN_APP: 'Legg merke til i appen',
    SHOW_NOTIFICATION: 'Vis varsel',
    NOTIFICATION_TEXT: 'Tekst for varsel',
    ALLERGY_INFO: 'Allergi info',
    PHONE_NUMBER: 'Telefonnummer',
    OPENING: 'Åpent klokke',
    CLOSING: 'Stengt klokka',
    SHOW_FACEBOOK: 'Vis Facebook-link på hjemmesiden',
    INSTAGRAM: 'Instagram',
    SHOW_INSTAGRAM: 'Vis Instagram-link på hjemmesiden',
    WHICH_ACTIVE: 'Hvilken skal aktiveres i appen?',
    SWISH: 'Swish',
    TAB: 'Bordbestilling',
    TABLENUMBER_FROM: 'Bord nr fra',
    TABLENUMBER_TO: 'Bord nr til',
    AREA_1: 'Område 1',
    AREA_2: 'Område 2',
    AREA_3: 'Område 3',
    AREA_4: 'Område 4',
    DELIVERY_RADIUS: 'Utkjøringsområde',
    DELIVERY_RADIUS_COST: 'Pris for utkjøring',
    BONUSSYSTEM: 'Bonussystem',
    LEAST_AMOUNT_BONUS: 'Minimum antall poeng for bruk av loyalitetspong',
    GLOBAL_OFFERS: 'Globale tilbud',
    APPLIES_TO_ALL: 'Gjelder alle i appen',
    ONETIME: 'Engang',
    USER_GROUPS: 'Brukergrupper',
    ADD_NEW: 'Legg til en ny',
    GROUP_NAME: 'Gruppenavn',
    DISCOUNT_CODES: 'Rabattkoder',
    DISCOUNTPERCENT: 'Rabattprosent',
    APPLY_AUTOMATICALLY: 'Bruk rabattkoden automatisk for kunder i appen',
    SEND_PUSH: 'Send push',
    SEND_PUSH_TEXT: 'Meldingen sendes umiddelbart til alle lokale brukere',
    SEND: 'Sende',
    ALTERNATIVES: 'Alternativ',
    HEADER_EX: 'Overskrift (f.eks. Grad av steking)',
    OPTION_TYPE: 'Legg til tilvalg',
    CHECKBOX: 'Merk av',
    MULTIPLE: 'Flere valg',
    PRICE: 'Pris',
    OPTIONS: 'Valgfri',
    COPY_FROM: 'Kopier fra',
    USING_STEP_BY_STEP: 'Bruk steg for steg',
    HEADER: 'Overskrift',
    SUBHEADER: 'Underoverskrift',
    LINK_WITH: 'Koblet sammen med',
    EDIT_EXCEPTION: 'Endre unntak',
    REASON: 'Grunnen til',
    REASON_DETAILS: 'Årsak',
    ACCOUNTING: 'Regnskap',
    SEARCH_PRODUCT: 'Søk etter produkt',
    DELIVERY_TYPES: 'Leveringsmåte',
    REMOVE_EXCEPTION_CONFIRM: 'Vil du fjerne unntaket?',
    REMOVE_EXCEPTION: 'Fjern unntak!',
    SAVE_WITHOUT_ACCOUNTING: 'Du kan ikke lagre produkter uten regnskapsinformasjon og produkttype',
    REMOVE_PRODUCT_RESTURANTS: 'Vil du fjerne produktet på flere restauranter?',
    PRODUCT_SHARED: 'Delt produkt!',
    PRODUCT_INFORMATION: 'Produktinformasjon',
    BASIC_INFO: 'Grunnleggende informasjon',
    ACTIVE: 'Aktiv',
    PRODUCT_ACTIVE: 'Produktet er aktivt',
    PRICE_KR: 'Pris i',
    WEIGHT_BASED_PRODUCT: 'Vektbasert produkt',
    WEIGHT_BASED_HINT: 'Gjesten velger vekten i appen. Prisen beregnes som vekt i gram / 100 × pris per 100 g.',
    WEIGHT_BASED_APP_ONLY: 'Dette produktet er kun tilgjengelig i appen. Det kan ikke vises i expresskiosk eller weborder.',
    PRICE_PER_100G: 'Pris per 100 g',
    MIN_WEIGHT_G: 'Minste vekt (g)',
    MAX_WEIGHT_G: 'Høyeste vekt (g)',
    WEIGHT_STEP_G: 'Vektsteg (g)',
    PER_100_G: '/ 100 g',
    WEIGHT_CONFIG_INVALID: 'Ugyldig vektkonfigurasjon. Min må være minst steget, max må være større enn min, og (max − min) må være delelig med steget.',
    WEIGHT_BASED_INCOMPATIBLE: 'Vektbasert pris kan ikke kombineres med Build-a-Burger eller kombinerte produkter.',
    BONUS_CONVERT: 'Prosent som konverteres til bonuspoeng når du kjøper et produkt',
    BONUS_CONVERT_WALLET: 'Prosent som konverteres til bonuspoeng når du kjøper mobile wallet',
    NOT_ALLOWED_TO_BY_WITH_BONUS: 'Får inte köpas för bonuspoäng',
    DESCRIPTION_SHORT: 'Beskrivelse (kort)',
    LONG_DESCRIPTION: 'Lang beskrivelse',
    DESCRIPTION_LONG: 'Beskrivelse (lang)',
    CATEGORY_BONG_INFO: 'Kategori og bonginformasjon',
    NAME_ON_BONG: 'Navn på bong (valgfritt)',
    PRODUCT_TYPE: 'Produkttype',
    PRODUCT_CATEGORY: 'Produktkategori',
    BONG_CATEGORY: 'Bong-kategori',
    ACCOUNTING_VAT: 'Regnskap og merverdiavgift',
    EXCEPTION: 'Unntak',
    CONTAINS_ALCOHOL: 'Produktet inneholder alkohol',
    AGE_LIMIT: '18 års aldersgrense',
    PURCHASE: 'Kjøp',
    COST: 'Kostnad',
    MARGIN: 'Margin',
    TAGS: 'Merker',
    NEW_TAG: 'Ny tagg',
    EXTERNAL_ID: 'Ekstern ID',
    STOCK_BALANCE: 'Lagersaldo',
    COUNT: 'Antall',
    ACOUNTINGS: 'Kontering',
    VAT_RATE: 'Moms',
    VAT_RATES: 'Moms satser',
    ACCOUNTING_ACCOUNT: 'Regnskapskonto',
    NO_ACCOUNT: 'Ingen konto',
    ACCOUNTING_CREATED: 'Kontering opprettet',
    PAYMENT_TYPES: 'Betalingsmetode',
    ACTIVATED_PAYMENT_TYPES: 'Aktiverte betalingsmåter',
    ADITIONAL_PAYMENT_TYPES: 'Flere betalingsmåter',
    NO_PAYMENT_TYPES: 'har ingen betalingsmåter aktivert. Trykk på Flere betalingsmåter for å aktivere noen',
    ADDED: 'Lagt til',
    PAYMENT_FEES: 'Noen betalingsmåter er knyttet til gebyrer. Her velger du kontoer for disse',
    VAT: 'Mva',
    HOME: 'Hjem',
    RESTAURANT: 'Restaurant',
    MENU: 'Meny',
    REDEMPTION_AGREEMENT: 'Innløsningsavtale',
    MANAGE: 'Få til',
    REPORTS: 'Rapporter',
    ADMIN: 'Administrasjon',
    NEWS: 'Nyhetsfeed',
    APP: 'App',
    POS: 'KASSE',
    STAFF_CARD: 'Personalkort',
    MISC: 'Diverse',
    SETTINGS: 'Innstillinger',
    PAYMENT_METHOD: 'Betalingsmetode',
    PAYMENT_SOURCE: 'Betalingskilde',
    RESTURANT_INFO: 'Restaurantinformasjon',
    USERS: 'Bruker',
    SEE_ALL: 'Se alle ...',
    STATISTICS: 'Statistikk',
    DARK_MODE: 'Mørkt modus',
    SELECT_UNIT: 'Velg enhet',
    OPENING_H_SAVED: 'Åpningstider lagret',
    OPENING_H: 'Åpningstider',
    OPEN_CLOSE_AUTOMATICALLY: 'Åpne/stenge app automatisk',
    AUTO_OPENING_HOURS_TITLE: 'Automatiske åpningstider',
    AUTO_OPENING_HOURS_DESCRIPTION:
        'Huk av for at salgskanalene skal åpne og stenge automatisk etter åpningstidene og avvikene nedenfor. Uten avhuking vises åpningstidene kun som informasjon.',
    AUTO_OPENING_HOURS_ON:
        'Aktiv – salgskanalene åpner og stenger automatisk etter tidene nedenfor.',
    AUTO_OPENING_HOURS_OFF:
        'Ikke aktiv – åpningstidene vises kun som informasjon i salgskanalene og styrer ikke når dere åpner eller stenger.',
    AUTO_OPENING_HOURS_TAG_ON: 'Styrer åpning/stenging',
    AUTO_OPENING_HOURS_TAG_OFF: 'Kun informasjon',
    CLOSED: 'Lukket',
    OPENS: 'Åpner',
    CLOSES: 'Stenger',
    DEVIATIONS: 'Avvik',
    SELECT_LOGO: 'Velg logo ..',
    ORG_NO: 'Organisasjonsnummer',
    ADRESS: 'Adresse',
    ZIP_CODE: 'Postnummer',
    POST_ADR: 'postadresse',
    PHONE: 'Telefon',
    EMAIL: 'E-post',
    ABOUT_US: 'Om oss',
    ADD_USER: 'Legg til brukere',
    ADD_DOMAIN_AUTO: 'Legg til brukerdomener som automatisk legges til denne brukergruppen ved registrering',
    DOMAIN_EXAMPLE: '(f.eks. bare pubq.se ikke @ pubq.se)',
    LOAD: 'Laster',
    SELECT_BONG_CATEGORY: 'Velg Bong',
    SELECT_PRODUCT_CATEGORY: 'Velg produkt',
    SELECT_TYPE: 'Velg Type',
    SELECT_DATE_TIME: 'Velg dato og tid',
    OVERVIEW: 'Oversikt',
    NEW_ORDER: 'Ny bestilling',
    PERSONAL_BANK_DETAILS: 'Personlige og bankdetaljer',
    CART_ITEMS: 'Handlevogn varer',
    LATEST_ORDERS: 'Siste bestillinger',
    LOGO_AND_IMAGES: 'Logotyper og bilder',
    FONTS: 'Skrifter',
    DANGER: 'Fare',
    SUCCESS: 'Suksess',
    SECONDARY: 'Sekundær',
    BASE: 'Utgangspunkt',
    PRIMARY: 'Hoved',
    COLORS: 'Farger',
    ENVIRONMENT_IMAGES: 'Klikk her for å endre logo, miljøbilder',
    HIDE_ADVANCE_SETTINGS: 'Skjul forhåndsinnstillinger',
    SHOW_ADVANCE_SETTINGS: 'Vis forhåndsinnstillinger',
    NEW_THEME: 'Nytt tema',
    THEME_MAIN_TEXT: 'Endre fonter og farger for butikkfronten din',
    THEMING: 'Tema',
    CHOOSE: 'Velg ...',
    LINK_TO_PRODUCT: 'Link til produkt eller nettsted',
    START_WITH_HTTPS: 'må starte med https: //',
    WHERE_IS_PRODUCT: 'Hvor er produktet?',
    OFFER_INFO_PLACEHODLER: 'Informasjonstekst for tilbudet...',
    OPTION_DESCRIPTION: 'Beskrivelse av tilbudet',
    SELECT: 'Velg',
    DISCOUNT_PERCENTAGE_PLACEHOLDER: 'Antall prosent brukeren får rabatt',
    WRITE: 'Skriv...',
    SEARCH_PRODUCT_OR_TAG: 'Søk produkt eller tagg',
    STEP_PLACEHOLDER: "Fremgangsmåte for å bygge din høyre flyt",
    ABOUT_US_PLACEHOLDER: 'Om oss',
    DOMAIN_EX: 'Domenet f.eks. Pubq.se',
    TIME_CONTROL_MENU: 'Timer menyen',
    SET: 'Sett',
    SCHEDULE: 'Schedule',
    ACTIVATION_TIME: 'Aktiveringstid',
    ACTIVATE_MENU: 'Aktiver meny',
    WEEK: 'Uke',
    TIP_REPORT: 'Tipsrapport',
    DESC_GENERATE_REPORT: 'Rapporten genereres til en PDF-fil som lastes ned automatisk.',
    GENERATING_REPORT: 'Genererer rapporten',
    ERROR_TIP_REPORT: 'Noe gikk galt i generasjonen av tipsrapporten!',
    COMPANY_NAME: 'Selskapsnavn',
    EMAIL_NOT_VALID: "E-postadressen er ikke gyldig",

    //Banking info traslation
    BANKINFO_HEADER: 'Personlige og bankdetaljer',
    BANKINFO_SUB_HEADER: 'Fyll ut skjemaet',
    BANKINFO_FIRST_NAME: 'Fornavn',
    BANKINFO_LAST_NAME: 'Etternavn',
    BANKINFO_BUSINESS_NAME: 'Business Name',
    BANKINFO_PHONE_NUMBER: 'Telefonnummer til administrerende direktør',
    BANKINFO_EMAIL: 'E-post til administrerende direktør',
    BANKINFO_TAX_ID: 'Skatte-ID',
    BANKINFO_LIST_OF_OWNERS: 'Liste over eiere',
    BANKINFO_UPLOAD_IDENTIFCATION: 'Last opp identifikasjon',
    BANKINFO_ADD_OWNER: 'Legg til eiere',
    BANKINFO_BANK_NAME: 'Bank navn',
    BANKINFO_BANK_ACCOUNT_NUMBER: 'Bankkontonummer',
    BANKINFO_BANK_PROOF: 'Last opp bankskjermbilde',
    BANKINFO_SEND_VERIFICTION: 'Send for bekreftelse',
    MIN_LENGTH: 'min lengde',
    ZERO_NOTIFICATION: "Ingen nye varsler",
    //************************************* Pdf translation ***********************
    PDF_HEADER: 'Pdf-visning',
    PDF_DOWNLOAD: 'Last ned pdf',
    PDF_FORMAT: 'Velg Sidestørrelse',
    PDF_TEXT: 'Skriv inn tekst',
    PDF_TEXT_COLOR: 'Tekstfarge',
    PDF_BACKGROUND_COLOR: 'Bakgrunnsfarge',
    GRIN_HEADER: 'Returboks',
    GRIN_PACKAGES: 'Boks',
    GRIN_NONE: 'Ingen',
    EMPLOYEE_ID: 'Ansatt-ID',
    TAG_ID: 'Tag-ID',
    ENTER_EMPLOYEE_ID: 'Skriv inn ansatt-ID',
    ENTER_TAG_ID: 'Skriv inn tag-ID',
    MANUAL_ENTRY: 'Manuell inntasting',
    MANUAL_EMPLOYEE_ID: 'Ansatt-ID',
    MANUAL_TAG_ID: 'Tag-ID',
    ENTER_MANUAL_EMPLOYEE_ID: 'Skriv inn ansatt-ID',
    ENTER_MANUAL_TAG_ID: 'Skriv inn tag-ID',
    ADD_MANUAL_USER: 'Legg til manuell bruker',
    COMPLETED: "Fullført",
    ENABLED: 'Aktivert',
    DISABLED: 'Deaktivert',
    SETTINGS_UPDATED: "Innstillinger oppdatert.",
    SETTINGS_COULDNT_UPDATE: "Noe gikk galt. Kunne ikke oppdatere innstillinger.",
    CATERING_CUTOFF_TIME_UPDATED: "Bestillingsfrist oppdatert",
    CATERING_CUTOFF_TIME_COULDNT_UPDATE: "Noe gikk galt. Kunne ikke oppdatere bestillingsfristen.",
    ALLERGEN_DESCRIPTION: 'Allergen Beskrivelse',
    AUTO_APPROVE_ORDERS_HEADER: 'Godkjenn bestillinger automatisk',
    AUTO_APPROVE_ORDERS_DESCRIPTION: 'Godkjenn innkommende cateringbestillinger automatisk uten manuell gjennomgang.',
    SHOW_MANDATORY_POPUP_FOR_DATE_HEADER: 'Obligatorisk popup for datovalg',
    SHOW_MANDATORY_POPUP_FOR_DATE_DESCRIPTION: 'Vis en popup i catering-webappen som krever at kunden velger en dato før menyen vises.',
    NOTIFICATION_EMAILS_HEADER: 'E-postvarsler for bestillinger',
    NOTIFICATION_EMAILS_DESCRIPTION: 'Legg til e-postadresser for å motta varsler om nye cateringbestillinger. Flere e-postadresser kan legges til.',
    NOTIFICATION_EMAIL_LANGUAGE: 'Språk for varslingsmail',
    ADD_EMAIL: 'Legg til e-post',
    ENTER_EMAIL_ADDRESS: 'Skriv inn e-postadresse',
    ADDED_EMAILS: 'Tilføyde e-postadresser',
    NO_EMAILS_ADDED: 'Ingen e-postadresser lagt til',
    INVALID_EMAIL_FORMAT: 'Ugyldig e-postformat',
    EMAIL_ALREADY_EXISTS: 'E-postadressen finnes allerede',
    START_TIME_MUST_BE_LESS_THAN_END_TIME: "Starttid må være mindre enn sluttid",
    START_AND_END_TIME_CANNOT_BE_SAME: "Starttid og sluttid kan ikke være samme",
    TIME_SLOT_OVERLAPS_WITH_ANOTHER: "Denne tidsluken overlapper med en annen tidsluke",
    START_DATE_REQUIRED: "Startdato kreves for å legge til hentings-/leveringsdatoer",
    DATE_ALREADY_EXISTS: "Denne datoen er allerede lagt til. Velg en annen dato.",
    END_DATE_AFTER_START_DATE: "Sluttdato må være etter startdato",
    BOTH_DATES_PASSED_WARNING: "Både start- og sluttdato har passert. Oppdater datoene før du aktiverer denne menyen.",
    PAST_DATE_RANGE_EDIT_WARNING: "Både start- og sluttdatoen er i fortiden. Oppdater sluttdatoen til i dag eller senere for å redigere startdatoen.",
    PAST_SCHEDULE_DATES_WARNING: "En eller flere hente-/leveringsdatoer er i fortiden. Oppdater eller fjern gamle datoer for å lagre endringer.",
    CATERING_PRODUCTION_DAYS_HEADER: 'Produksjonsdager',
    CATERING_PRODUCTION_DAYS_DESCRIPTION: 'Konfigurer hvilke ukedager som telles som produksjonsdager ved beregning av minimum hentedato. Dager som ikke er produksjonsdager vil bli hoppet over når man teller ledetid.',
    CATERING_PRODUCTION_DAYS_LABEL: 'Dager som telles som produksjonsdager',
    CATERING_MENU_PREFERENCE_HEADER: 'Produktmenutype',
    CATERING_MENU_PREFERENCE_DESCRIPTION: 'Velg hvilken menutype som skal vise et produkt hvis det finnes i både Normal- og Kampanjemenyer. Når et produkt legges til i begge menutyper, vil det kun vises i den menutypen som velges her i innstillingene.',
    IMPORTANT: 'Viktig',
    MENU_PREFERENCE_NOTE: 'Et produkt kan kun tilhøre én menutype. Hvis det vises i både Kampanje- og Normalmenyer, vil det vises i henhold til din valgte menupreferanse.',
    CATERING_SELECT_MENU_TYPE: 'Velg menutype',
    CATERING_MENU_PREFERENCE_NOTE: 'Hvis et produkt legges til i begge menutyper, vil det kun vises i den foretrukne menutypen.',
    CATERING_CAMPAIGN_MENU: 'Kampanje',
    CATERING_REGULAR_MENU: 'Normal',
    DEVIATION_INCOMPLETE: 'Anledning, startdato og sluttdato er påkrevd',
    DEVIATION_START_DATE_IN_PAST: 'Startdato kan ikke være før i dag',
    DEVIATION_END_DATE_IN_PAST: 'Sluttdato kan ikke være før i dag',
    OVERLAPPING_DEVIATION_DATE_RANGE: 'Dette datointervallet overlapper med en annen avvikelse',
    OVERLAPPING_TIME_SLOT:'Overlapper med eksisterende tid',
    END_TIME_BEFORE_START_TIME:'Sluttid kan ikke være før starttid',
    KIOSK_INFORMATION: 'Kiosk-plasseringer',
    ORDER_LIST_APP_HINT: 'Dra for å endre visningsrekkefølge i appen. Klikk på Lagre ovenfor for å bruke.',
    ORDER_LIST_KIOSK_HINT: 'Dra for å endre visningsrekkefølge for kiosk-plasseringer. Klikk på Lagre ovenfor for å bruke.',
    YES_DELETE: 'Ja, slett',
    TABLE_QR_CODE: 'Bordets QR-kode',
    TABLE_DETAILS: 'Borddetaljer',
    TABLE_MANAGMENT: 'Bordadministrasjon',
    TABLE_MANAGMENT_DESCRIPTION: 'Administrer bordgrupper. Hver gruppe definerer et intervall av bord (f.eks. 70–100). Bordene genereres dynamisk — ingenting lagres individuelt.',
    SERVING_METHOD_NAME: 'Navn på serveringsmetode',
    SERVING_METHOD_NAME_DESC: 'Konfigurer hvordan denne serveringsmetoden skal vises i salgskanalene.',
    TABLE_SERVING_OPTION: 'Bordservering',
    SEAT_SERVING_OPTION: 'Plasservering',
    TABLE_SERVING_DESCRIPTION: 'La gjester bestille direkte til bordet',
    SEAT_SERVING_DESCRIPTION: 'La gjester bestille direkte til plassen',
    TABLE: 'Bord',
    NEW_GROUP: 'Ny gruppe',
    DOWNLOAD_ALL_QR: 'Download alle QR-koder',
    UNIT_NAME: 'Enhetsnavn',
    WEB_ORDER_BASE_URL: 'Nettbestilling base-URL',
    CREATE_TABLE_GROUP: 'Opprett bordgruppe',
    EDIT_TABLE_GROUP:' Rediger bordgruppe',
    CREATE_SEAT_GROUP: 'Opprett plassgruppe',
    EDIT_SEAT_GROUP: 'Rediger plassgruppe',
    TABLE_RANGE:'Bordintervall',
    SEAT_RANGE: 'Plassintervall',
    TABLES_WILL_GENERATE:'Dette vil generere {count} bord',
    SEATS_WILL_GENERATE: 'Dette vil generere {count} plasser',
    END_MUST_BE_GREATER_EQUAL_START:'Slutt må være ≥ Start',
    SELECT_ALL: 'Velg alle',
    DOWNLOAD_RANGE: 'Download intervall',
    QR_CODE:'QR-kode',
    FORMAT: 'Format',
    DOWNLOAD_AS: 'Download som',
    TABLES: 'Bord',
    SEATS: 'Plasser',
    SEAT: 'Plass',
    SEAT_GROUPS: 'Plassgrupper',
    SEAT_MANAGEMENT_DESCRIPTION: 'Administrer plassgrupper. Hver gruppe definerer et intervall med plasser (f.eks. 70–100). Plasser genereres dynamisk – ingenting lagres individuelt.',
    VIEW_TABLES: 'Vis bord',
    VIEW_SEATS: 'Vis plasser',
    NO_TABLE_GROUPS_YET: 'Ingen bordgrupper ennå',
    NO_SEAT_GROUPS_YET: 'Ingen plassgrupper ennå',
    GROUP_NAME_REQUIRED: 'Gruppenavn er påkrevd',
    UNIT_NAME_REQUIRED: 'Enhetsnavn er påkrevd',
    WEB_ORDER_URL_REQUIRED: 'Webbestillings-URL er påkrevd',
    SEO_SETTINGS: 'SEO-innstillinger',
    SEO_SETTINGS_DESC: 'Konfigurer metadata for søkemotoroptimalisering for å forbedre synligheten på Google.',
    SEO_TITLE: 'SEO-tittel',
    SEO_TITLE_NOTE: 'Tittel som vises i Google-søkeresultater og nettleserfanen. La stå tomt for å bruke standardtittel.',
    SEO_DESCRIPTION: 'SEO-beskrivelse (Metabeskrivelse)',
    SEO_DESCRIPTION_NOTE: 'Kort sammendrag som vises under tittelen i Google-søkeresultater. Anbefalt lengde: 120-160 tegn.',
    TABLE_RANGE_REQUIRED: 'Bordområde er påkrevd',
    SEAT_RANGE_REQUIRED: 'Plassområde er påkrevd',
    START_MUST_BE_LESS_EQUAL_END: 'Start må være ≤ Slutt',
    MAX_1000_TABLES_ALLOWED: 'Området kan ikke overstige 1000 bord per gruppe',
    MAX_1000_SEATS_ALLOWED: 'Området kan ikke overstige 1000 plasser per gruppe',
    DELETE_GROUP: 'Slett gruppe',
    DELETE_GROUP_CONFIRM: 'Slett "{group}" ({tables} {start}–{end})? Dette kan ikke angres.',
    GROUP_DELETED: 'Gruppen ble slettet',
    FAILED_DELETE_GROUP: 'Kunne ikke slette gruppen',
    SEARCH_GROUPS: 'Søk grupper...',
    DOWNLOADED:'Nedlastet',
    DOWNLOADING_QR_CODES:'Laster ned QR-koder',
    STAMP_CARD_DELIVERY_METHODS: 'Leveringsmetoder',
    STAMP_CARD_DELIVERY_METHODS_HINT: 'Alle metoder er tillatt som standard; fjern avkryssing for å begrense hvilke leveringsmetoder som skal gjelde.',
    STAMP_CARD_DM_EAT_IN: 'Spis her',
    STAMP_CARD_DM_TAKEAWAY: 'Takeaway',
    STAMP_CARD_DM_DELIVER_TO_WORKPLACE: 'Lever til arbeidsplass',
    STAMP_CARD_DM_DELIVERY: 'Levering',
    STAMP_CARD_DM_TABLE_SERVING: 'Bordservering',
    SALES_CHANNELS: 'Salgskanaler',
    CHANNEL_APP: 'App',
    CHANNEL_KIOSK: 'Kiosk',
    CHANNEL_POS: 'POS',
    CHANNEL_WEB: 'Web',
    CUSTOMER_VISIBILITY: 'Kundesynlighet',
    ALL_CUSTOMERS: 'Alle kunder',
    LOGGED_IN_USERS_ONLY: 'Kun innloggede brukere',
    ADDON_SERVING_METHODS: 'Serveringsmetoder',
    ADDON_SERVING_METHODS_HINT: 'Alle serveringsmetoder er aktivert som standard. Fjern avkryssing for å skjule dette tilvalget for en metode.',
    ADDONS_V2_RULES_SECTION: 'Valgregler',
    ADDON_WIZARD_RULES: 'Regler',
    ADDON_LABEL_SELECTION_TYPE: 'Valgtype',
    ADDON_LABEL_PRESELECT_MODE: 'Forhåndsvalgt modus',
    ADDON_LABEL_MIN_SELECTIONS: 'Min. antall valg',
    ADDON_LABEL_MAX_SELECTIONS: 'Maks. antall valg',
    ADDON_REQUIRED_BEFORE_PROCEED: 'Påkrevd før gjesten kan fortsette',
    ADDON_LABEL_PRESELECTED_OPTION: 'Forhåndsvalgt alternativ',
    SHOW_WHEN_RULES: 'Når skal det vises',
    SHOW_WHEN_HINT: 'Denne gruppen vises kun når spesifikke betingelser er oppfylt fra en annen gruppes valg.',
    ACTIVE_DEPENDENCIES: 'Aktive avhengigheter',
    DEPENDS_ON_GROUP: 'Avhenger av gruppe',
    OPTIONS_TO_TRIGGER: 'Alternativer som utløser',
    ADD_DEPENDENCY: 'Legg til avhengighet',
    SHOW_WHEN_GROUP_PREFIX: 'Vis når gruppen',
    SHOW_WHEN_INCLUDES_VERB: 'inneholder',
    ADDON_VALIDATE_INVALID_PAYLOAD: 'Ugyldige tilvalsregler',
    ADDON_VALIDATE_MAX_SELECTIONS_RADIO: 'Grupper med ett valg må ha maks antall valg = 1',
    ADDON_VALIDATE_PRESELECT_SPECIFIC: 'Velg et forhåndsvalgt alternativ eller endre modus',
    ADDON_VALIDATE_MAX_LT_MIN: 'Maks antall valg kan ikke være lavere enn min.',
    ADDON_SELECT_ONE_RADIO: 'Ett valg (radio)',
    ADDON_SELECT_MULTIPLE_CHECKBOX: 'Flere valg (avkryssing)',
    ADDON_PRESELECT_NONE: 'Ingen',
    ADDON_PRESELECT_FIRST: 'Første alternativ',
    ADDON_PRESELECT_SPECIFIC: 'Bestemt alternativ',
    SUBTITLE_LABEL: 'Undertittel',
    ALWAYS_VISIBLE: 'Alltid synlig',
    VISIBLE_IN_DELIVERY_MENU: 'Synlig i leveringsmeny',
    VISIBLE_IN_TAKEAWAY_MENU: 'Synlig i takeaway-meny',
    VISIBLE_IN_EATIN_MENU: 'Synlig i spise-her-meny',
    VISIBLE_IN_TABLEORDER_MENU: 'Synlig i bordbestillingsmeny',
    VISIBLE_IN_DELIVERYSETLOCATION_MENU: 'Synlig i fast leveringsstedsmeny',
    COMMENT_FIELD_ON_ORDER: 'Kommentarfelt på bestilling',
    COMMENT_FIELD_DESCRIPTION: 'Aktiver eller deaktiver kommentarfeltet i utsjekkingen.',
    CAROUSEL: 'Samlinger',
    SLIDE_PLAYBACK_FAILED: 'Avspilling mislyktes',
    MENU_DISPLAY: 'Menydisplay',
    // Signage (menu display)
    MENUDISPLAY_MENU_DISPLAY_CONFIG_SUBTITLE: 'Konfigurer logo, bakgrunn, skriftfarge og synlighet for produktbilde.',
    MENUDISPLAY_TOGGLE_ON: 'På',
    MENUDISPLAY_TOGGLE_OFF: 'Av',
    MENUDISPLAY_FONT_COLOR_HEX_PLACEHOLDER: '#000000',
    MENUDISPLAY_FONT_FAMILY_TITLE: 'Skrifttype',
    MENUDISPLAY_FONT_FAMILY_SUBTITLE: 'Velg en Google Font for menytekst på skjermen.',
    MENUDISPLAY_FONT_PREVIEW_SAMPLE: 'Eksempel: Aa Bb Cc 0123456789',
    MENUDISPLAY_LOGO_TITLE: 'Logo',
    CHANGE_LOGO: 'Bytt logo',
    MENUDISPLAY_UPLOADED: 'Lastet opp',
    MENUDISPLAY_NOT_SET: 'Ikke satt',
    MENUDISPLAY_LOGO_PREVIEW_ALT: 'Logo-forhåndsvisning',
    MENUDISPLAY_REPLACE_IMAGE: 'Bytt bilde',
    MENUDISPLAY_CLICK_TO_UPLOAD_LOGO: 'Klikk for å laste opp',
    MENUDISPLAY_LOGO_UPLOAD_HINT: 'PNG, JPG, SVG · Anbefalt 400×400px',
    MENUDISPLAY_CUSTOM_MENU_DISPLAY_TITLE: 'Egendefinert menydisplay',
    MENUDISPLAY_CUSTOM_MENU_DISPLAY_SUBTITLE: 'Opprett og administrer gjenbrukbare produktgrupper for skjermbilder.',
    CUSTOM_MENU_DISPLAY_SAVE_SUCCESS: '"{name}" er lagret.',
    CUSTOM_MENU_DISPLAY_SAVE_ERROR: 'Kunne ikke lagre den egendefinerte visningen. Prøv igjen.',
    MENUDISPLAY_BACKGROUND_PREVIEW_ALT: 'Bakgrunn-forhåndsvisning',
    MENUDISPLAY_CLICK_TO_UPLOAD_BACKGROUND: 'Klikk for å laste opp bakgrunn',
    MENUDISPLAY_BACKGROUND_UPLOAD_HINT: 'PNG, JPG · Anbefalt 1920×1080px',
    MENUDISPLAY_CHANGE_IMAGE: 'Bytt bilde',
    MENUDISPLAY_UNSAVED_CHANGES_HINT: 'Du har ulagrede endringer',
    MENUDISPLAY_LOADING_ARIA_LABEL: 'laster',
    MENUDISPLAY_LOADING_THEME_SETTINGS_TEXT: 'Laster temainnstillinger…',
    // Signage (carousel)
    SLIDE_IMAGE_ALT: 'slide-bilde',
    SLIDE_DELAY_SECONDS_SUFFIX: 'sek',
    SLIDE_CREATE_SUBTITLE: 'Legg til en ny slide i skiltingen din',
    SLIDE_EDIT_SUBTITLE: 'Oppdater denne sliden i skiltingen din',
    SLIDE_DELAY_SECONDS: 'Forsinkelse i sekunder',
    SLIDE_DELAY_HINT: 'Hvor lenge denne sliden skal vises',
    SLIDE_VIDEO_TYPE: 'Video',
    SLIDE_VIDEO: 'Slide video',
    SLIDE_VIDEO_FILE: 'Videofil',
    SLIDE_VIDEO_ALT: 'slide video',
    SLIDE_FILE_UPLOADED: 'Fil lastet opp',
    SLIDE_VIDEO_FORMATS_HINT: 'Støttede formater: MP4. Maks. størrelse: 50 MB.',
    SLIDE_VIDEO_DURATION_HINT: 'Hentet fra den opplastede videofilen',
    UPLOAD_VIDEO: 'Last opp video',
    VIDEO_GALLERY: 'Video galleri',
    VIDEO_URL: 'Video URL',
    VIDEO_DURATION: 'Varighet (sekunder)',
    VIDEO_SLIDE: 'Video slide',
    VIDEO_TOO_LARGE: 'Videofil må være maks 50MB',
    VIDEO_TOO_LONG: 'Video må være maks 60 sekunder',
    VIDEO_INVALID_FORMAT: 'Kun MP4-filer støttes',
    VIDEO_PROBE_FAILED: 'Kan ikke lese videometadata',
    VIDEO_UPLOAD_FAILED: 'Video opplasting feilet',
    SIGNAGE_MIN_3_CHARACTERS: 'Minst 3 tegn',
    COLLECTION_CREATED_SUCCESS: 'Samlingen ble opprettet',
    COLLECTION_UPDATED_SUCCESS: 'Samlingen ble oppdatert',
    CURRENT_WEEK: 'Gjeldende uke',
    NEXT_WEEK: 'Neste uke',
    ROLLOVER_SETTINGS: 'Rollover-innstillinger',
    ROLLOVER_DESCRIPTION: 'Bestem når bestillingsappen skal tilby neste uke for forhåndsbestillinger.',
    ROLLOVER_ENABLED: 'Automatisk ukeskifte',
    ROLLOVER_ENABLED_HINT: 'Når aktivert flyttes neste uke til gjeldende på valgt dag/tid.',
    ROLLOVER_CUTOFF_DAY: 'Skiftdag',
    ROLLOVER_CUTOFF_TIME: 'Skifttid',
    ROLLOVER_NOW: 'Skift uke nå',
    ROLLOVER_CONFIRM_MESSAGE: 'Dette flytter neste uke til gjeldende uke. Neste uke beholdes som den er — bruk "Tilbakestill neste uke" hvis du vil tømme den. Fortsette?',
    ROLLOVER_PERFORMED: 'Ukeskifte utført',
    ROLLOVER_FAILED: 'Ukeskifte mislyktes',
    ROLLOVER_SETTINGS_SAVED: 'Innstillinger for ukeskifte lagret',
    NEXT_ROLLOVER_IN: 'Kunder starter å bestille for neste uke fra',
    MANUAL_ACTIONS: 'Manuelle handlinger',
    MANUAL_ROLLOVER_DESCRIPTION: 'Uker lagres etter ukenummer, så det er ikke noe dataskifte å kjøre. Bruk disse handlingene til å fylle eller tømme neste uke manuelt.',
    CLONE_CURRENT_TO_NEXT: 'Kopier gjeldende til neste',
    CLONE_CURRENT_TO_NEXT_CONFIRM: 'Dette overskriver neste uke med en kopi av gjeldende uke. Fortsette?',
    CLONE_CURRENT_TO_NEXT_DONE: 'Gjeldende uke kopiert til neste',
    CLONE_CURRENT_TO_NEXT_FAILED: 'Kunne ikke kopiere gjeldende til neste',
    RESET_NEXT_WEEK: 'Tilbakestill neste uke',
    RESET_NEXT_WEEK_CONFIRM: 'Dette tømmer neste uke tilbake til en tom mal (ingen produkter, helger stengt). Fortsette?',
    RESET_NEXT_WEEK_DONE: 'Neste uke tilbakestilt til tom mal',
    RESET_NEXT_WEEK_FAILED: 'Kunne ikke tilbakestille neste uke',
    REMOVE_ORPHAN_WEEKLY_MENUS: 'Fjern {{count}} gamle uke-menyuker',
    REMOVE_ALL_PAST_WEEKS_CONFIRM: 'Fjerne {{count}} tidligere uke(r) fra Firebase? Gjeldende og neste uke beholdes. Dette kan ikke angres.',
    REMOVE_ALL_PAST_WEEKS_DONE: 'Fjernet {{count}} tidligere uke(r)',
    REMOVE_ALL_PAST_WEEKS_FAILED: 'Kunne ikke fjerne tidligere uker',
    TIME_SETTINGS: 'Tidsinnstillinger',
    NO_PRODUCTS_YET: 'Ingen produkter ennå',
    ALL_PRODUCTS_ALREADY_ADDED: 'Alle produkter er allerede lagt til',
    NO_WEEKLY_MENU_PRODUCTS_ENABLED: 'Ingen produkter er aktivert for ukemeny. Aktiver produkter under produktets avanserte innstillinger for å legge dem til i ukemenyen.',
    ENABLE_MORE_PRODUCTS_HINT: 'For å legge til flere produkter, aktiver dem under Produkt > Avanserte innstillinger.',
    ADD_PRODUCTS: 'Legg til produkter',
    ADD_MORE_PRODUCTS: 'Legg til flere produkter',
    SELECTED_PRODUCTS: 'Valgte produkter',
    NO_PRODUCTS_SELECTED_FOR_DAY: 'Ingen produkter er lagt til for denne dagen ennå',
    SCHEDULED_TAG: 'Planlagt',
    ACTIVE_TAG: 'Aktiv',
    TODAY_LABEL: 'I dag',
    ALL_DAYS: 'Alle dager',
    DAYS_SELECTED_LABEL: '{0} dager valgt',
    ALL_WEEKS_LABEL: 'Alle uker',
    CURRENT_WEEK_LABEL: 'Gjeldende uke',
    UPCOMING_WEEK_LABEL: 'Kommende uke',
    WEEK_SCOPE_PLACEHOLDER: 'Uke',
    DAYS_LABEL: 'Dager',
    WEEKLY_TIMELINE_HEADER: 'Ukestidslinje',
    WEEKLY_SCOPED_READONLY_BANNER: 'Denne ukebestillingen kan kun fullføres på planlagt dag.',
    WEEKLY_SCOPED_START_PREPARING_BTN: 'Start tilberedning',
    WEEKLY_SCOPED_STARTED_SUCCESS_SUMMARY: 'Tilberedning startet',
    WEEKLY_SCOPED_STARTED_SUCCESS_DETAIL: 'Uke-scopet bestilling er nå i gang.',
    WEEKLY_SCOPED_MISSING_ETA_SUMMARY: 'Ingen ferdigtid for denne dagen',
    WEEKLY_SCOPED_MISSING_ETA_DETAIL: 'Sett en timer når du starter tilberedning hvis du vil se nedtelling her.',
    WEEKLY_SCOPED_PENDING_SELECTION_HINT: 'Start tilberedning for å låse opp valg av linjer for denne dagen.',
    SC_USERS_CARD_RECORDS: 'Kortposter',
    SC_USERS_READY_TO_REDEEM: 'Klar til innløsning',
    SC_USERS_AVG_STAMPS: 'Gj.snitt stempler per kort',
    SC_USERS_SEARCH_PLACEHOLDER: 'Søk på navn, bruker-ID eller kort...',
    SC_USERS_NO_RECORDS: 'Ingen brukerposter funnet.',
    SC_DEACTIVATED_BY_ADMIN: 'Deaktivert av admin',
    SC_DEACTIVATED: 'Deaktivert',
    SC_CARD_ACTIVE: 'Kort aktivt',
    SC_CARD_INACTIVE: 'Kort inaktivt',
    SC_USER_DEACTIVATED: 'Bruker deaktivert',
    SC_USER_ACTIVE: 'Bruker aktiv',
    SC_DEACTIVATED_BANNER: 'Dette kortet er deaktivert for denne brukeren — stempler bevares, men innløsning er blokkert til det reaktiveres.',
    SC_STAMP_PROGRESS: 'Stempel fremgang',
    SC_LAST_STAMP: 'Siste stempel',
    SC_LAST_REDEEMED: 'Sist innløst',
    SC_LAST_USED_DATE: 'Dato for siste aktivitet',
    SC_CARD_NAME: 'Kortnavn',
    SC_CARD_ID: 'Kort-ID',
    SC_ADD_STAMP: 'Legg til stempel',
    SC_REMOVE_STAMP: 'Fjern stempel',
    SC_NO_STAMPS_TO_REMOVE: 'Ingen stempler å fjerne',
    SC_MAX_STAMPS_REACHED: 'Maks stempler nådd – merk som innløst',
    SC_NOT_READY_TO_REDEEM: 'Kortet er ikke klart for innløsning ennå',
    SC_MARK_REDEEMED: 'Merk som innløst',
    SC_DEACTIVATE: 'Deaktiver',
    SC_REACTIVATE: 'Reaktiver',
    SC_LOADING_HISTORY: 'Laster historikk…',
    SC_NO_HISTORY: 'Ingen aktivitet registrert ennå.',
    SC_LOG_STAMP_ADDED: 'Stempel samlet',
    SC_LOG_REDEEMED: 'Innløst',
    SC_LOG_ADMIN_STAMP_ADDED: 'Admin: Stempel lagt til',
    SC_LOG_ADMIN_STAMP_REMOVED: 'Admin: Stempel fjernet',
    SC_LOG_ADMIN_REDEEMED: 'Admin: Markert som innløst',
    SC_LOG_ADMIN_DEACTIVATED: 'Admin: Kort deaktivert',
    SC_LOG_ADMIN_REACTIVATED: 'Admin: Kort reaktivert',
    SC_STAMP: 'stempel',
    SC_STAMPS: 'stempler',
    SC_REFRESH: 'Oppdater',
    SC_USER_COL: 'Bruker',
    SC_STAMP_CARD_COL: 'Stempelkort',
    SC_STAMPS_COL: 'Stempler',
    SC_PROGRESS_COL: 'Fremgang',
    SC_NOT_READY: 'Ikke klar',
    SC_ALL_CARDS: 'Alle kort',
    SC_STAMP_CARD_DETAILS: 'Stempelkortdetaljer',
    SC_FAILED_LOAD_PROGRESS: 'Kunne ikke laste brukerframgang',
    CATERING_COMMUNICATION_TAB: 'Kommunikasjon',
    CATERING_THEME_TAB: 'Tema',
    CATERING_HERO_IMAGE_AND_LOGO_HEADER: 'Hero-bilde og logo',
    CATERING_HERO_IMAGE_AND_LOGO_DESCRIPTION: 'Konfigurer hero-bilde og logo.',
    CATERING_BUTTON_COLORS_HEADER: 'Knappsfarger',
    CATERING_BUTTON_COLORS_DESCRIPTION: 'Tilpass den primære knappefargen og tekstfargen som brukes i Catering-webappen.',
    CATERING_BUTTON_PRIMARY_COLOR: 'Primær knappefarge',
    CATERING_BUTTON_TEXT_COLOR: 'Tekstfarge for knapp',
    CATERING_FONTS_HEADER: 'Tema-skrifttyper',
    CATERING_FONTS_DESCRIPTION: 'Konfigurer tittel- og brødtekstskrifttyper.',
    CATERING_TITLE_FONT_LABEL: 'Tittelskrifttype',
    CATERING_BODY_FONT_LABEL: 'Brødtekstskrifttype',
    CATERING_THEME_LOGO_HEADER: 'Logo',
    CATERING_THEME_HERO_IMAGE_HEADER: 'Hero-bilde',
    CATERING_THEME_PREVIEW_HEADER: 'Forhåndsvisning',
    CATERING_THEME_PREVIEW_BTN_SOLID: 'Knapp',
    CATERING_THEME_PREVIEW_BTN_OUTLINED: 'Omriss',
    CATERING_THEME_PREVIEW_BTN_TEXT: 'Tekst',
    CATERING_THEME_REPLACE: 'Erstatt',
    CORPORATE_CUSTOMERS: 'Bedriftskunder',
    INVOICE_MENU: 'Faktura',
    INVOICES: 'Fakturaer',
    INVOICE_LIST_SUBTITLE: 'POS-fakturaer som venter på manuell videresending til regnskap.',
    INVOICE_LIST_SEARCH: 'Søk selskap, org.nr eller faktura…',
    INVOICE_LIST_EMPTY: 'Ingen fakturaer ennå',
    INVOICE_LIST_EMPTY_DESCRIPTION: 'Fakturaer fra POS-fakturabetalinger vises her. Prøv å justere datoperiode eller filtre.',
    INVOICE_LIST_LOAD_FAILED: 'Kunne ikke laste fakturaer',
    INVOICE_LIST_DATE_RANGE: 'Velg datoperiode',
    INVOICE_LIST_TEXT_SEARCH_HINT: 'Søket treffer selskap, org.nr, fakturanummer og kvitteringsnummer i valgt datoperiode (opptil 100 siste fakturaer).',
    INVOICE_LIST_PREVIOUS: 'Forrige',
    INVOICE_LIST_NEXT: 'Neste',
    INVOICE_LIST_PAGE: 'Side',
    INVOICE_STATUS_CREATED: 'Opprettet',
    INVOICE_STATUS_SENT: 'Sendt',
    INVOICE_MARK_SENT: 'Merk som sendt',
    INVOICE_MARKED_SENT: 'Faktura merket som sendt',
    INVOICE_MARK_SENT_FAILED: 'Kunne ikke oppdatere fakturastatus',
    INVOICE_PDF_FAILED: 'Kunne ikke opprette faktura-PDF',
    OPEN_INVOICE: 'Åpne faktura',
    INVOICE_DOWNLOAD_SELECTED: 'Last ned valgte',
    INVOICE_LOADING_DETAILS: 'Laster fakturadetaljer...',
    INVOICE_TITLE: 'Faktura',
    INVOICE_BILL_FROM: 'Faktura fra',
    INVOICE_BILL_TO: 'Faktura til',
    INVOICE_ISSUED_ON: 'Utstedt',
    INVOICE_DETAIL: 'Fakturadetaljer',
    INVOICE_GRAND_TOTAL: 'Totalsum',
    INVOICE_RECEIPT_LINES_UNAVAILABLE: 'Kvitteringslinjer er ikke tilgjengelige.',
    INVOICE_RECEIPT_DATA_UNAVAILABLE: 'Kvitteringsdata er ikke tilgjengelige',
    INVOICE_NOT_AVAILABLE: 'Ikke tilgjengelig',
    INVOICE_CORPORATE_CUSTOMER: 'Bedriftskunde',
    INVOICE_PAYMENT_METHOD: 'Betalingsmetode',
    INVOICE_GENERATED_ON: 'Generert',
    INVOICE_PAGE_OF: 'Side {0} av {1}',
    INVOICE_DESCRIPTION: 'Beskrivelse',
    INVOICE_UNIT_PRICE: 'Enhetspris',
    INVOICE_QTY: 'Antall',
    INVOICE_VAT: 'MVA',
    INVOICE_DISCOUNT: 'Rabatt',
    INVOICE_TOTAL: 'Totalt',
    CORPORATE_CUSTOMERS_SUBTITLE: 'Administrer selskaper og deres leveringslokasjoner for cateringtjenester.',
    CREATE_CORPORATE_CUSTOMER: 'Opprett bedriftskunde',
    COMPANY_EMAIL: 'Bedriftens e-post',
    LOCATIONS: 'Lokasjoner',
    BILLING_INFO: 'Faktureringsinfo',
    NO_CORPORATE_CUSTOMERS_TITLE: 'Ingen bedriftskunder ennå',
    NO_CORPORATE_CUSTOMERS_DESCRIPTION: 'Opprett din første bedriftskunde for å administrere faktureringskontakter og leveringslokasjoner.',
    CREATE_FIRST_CORPORATE_CUSTOMER: 'Opprett første bedriftskunde',
    ORGANIZATION_NUMBER: 'Organisasjonsnummer',
    ORGANIZATION_ID: 'Organisasjons-ID',
    NEXT: 'Neste',
    EDIT_CORPORATE_CUSTOMER: 'Rediger bedriftskunde',
    LEGAL_ENTITY_INFORMATION: 'Juridisk enhetsinformasjon',
    LEGAL_NAME: 'Juridisk navn',
    VAT_NUMBER: 'MVA-nummer',
    BILLING_ADDRESS: 'Faktureringsadresse',
    STREET_ADDRESS: 'Gateadresse',
    POSTAL_CODE: 'Postnummer',
    INVOICE_SETTINGS: 'Fakturainnstillinger',
    DELIVERY_METHOD: 'Leveringsmetode',
    INVOICE_EMAIL: 'Faktura-e-post',
    PAYMENT_TERMS_DAYS: 'Betalingsbetingelser (dager)',
    BILLING_CONTACT: 'Kontakt',
    CONTACT_NAME: 'Kontaktnavn',
    ADDED_LOCATIONS: 'Lagt til lokasjoner',
    ADD_DELIVERY_LOCATION: 'Legg til leveringslokasjon',
    FLOOR: 'Etasje',
    ENTRANCE_CODE: 'Inngangskode',
    DEFAULT_REFERENCE: 'Standardreferanse',
    REVIEW_INFORMATION: 'Gjennomgå informasjon',
    LEGAL_ENTITY: 'Juridisk enhet',
    PAYMENT_TERMS: 'Betalingsbetingelser',
    SUB_LOCATIONS: 'Underlokasjoner',
    ADD_SUB_LOCATION: 'Legg til underlokasjon',
    ROOM_CODE: 'Romkode',
    SUB_LOCATION_NAME: 'Underlokasjonsnavn',
    STEP_COMPANY_INFO: 'Bedriftsinfo',
    STEP_BILLING_AND_INVOICE: 'Fakturering',
    NO_DELIVERY_LOCATIONS: 'Ingen leveringslokasjoner ennå',
    CORPORATE_CUSTOMER_CREATED: 'Bedriftskunde opprettet.',
    CORPORATE_CUSTOMER_UPDATED: 'Bedriftskunde oppdatert.',
    CORPORATE_CUSTOMER_DELETED: 'Bedriftskunde slettet.',
    CORPORATE_CUSTOMER_SAVE_FAILED: 'Kunne ikke lagre bedriftskunde.',
    CORPORATE_CUSTOMER_DELETE_FAILED: 'Kunne ikke slette bedriftskunde.',
    CORPORATE_CUSTOMER_DELETE_CONFIRM: 'Er du sikker på at du vil slette denne bedriftskunden?',
    DELETE_CONFIRMATION: 'Bekreft sletting',
    DELIVERY_LOCATIONS_SUBTITLE: 'Leveringslokasjoner og underlokasjoner for dette selskapet',
    BILLING_INFO_SUBTITLE: 'Fakturerings- og fakturainformasjon for denne bedriftskunden',

    // Catering Orders – leverings- og fakturadetaljer
    DELIVERY_INFORMATION: 'Leveringsinformasjon',
    CORPORATE_COMPANY: 'Tilknyttet bedrift',
    COMPANY_PHONE: 'Bedriftens telefon',
    DELIVERY_LOCATION: 'Leveringslokasjon',
    DELIVERY_ROOM: 'Leveringsrom',
    DOOR_CODE: 'Dørkode',
    INVOICE_NUMBER: 'Fakturanummer',
    LOCATION_NAME: 'Lokasjonsnavn',
    EDIT_LOCATION_AND_SUBLOCATIONS: 'Rediger lokasjon og underlokasjoner',
    SUCCEEDED: 'Lykkedes',
    DELIVERY_ROOM_FLOOR: 'Etagenavn',
    DELIVERY_ROOM_DOOR_CODE: 'Rumkode',
    INGREDIENTS: 'Ingredienser',
    INGREDIENTS_DESCRIPTION: 'Velg ingredienser som er inkludert i dette produktet som standard.',
    SELECT_FROM_LIBRARY: 'Velg fra bibliotek',
    CHOOSE_INGREDIENTS: 'Velg ingredienser...',
    NO_INGREDIENTS_LIBRARY: 'Ingen ingredienser i biblioteket.',
    CREATE_NEW_INGREDIENT: 'Opprett ny ingrediens',
    INGREDIENT_PLACEHOLDER: 'F.eks. Løk',
    INGREDIENT_HINT: 'Trykk Enter eller klikk + for å legge til.',
    SELECTED_INGREDIENTS: 'Valgte ingredienser',
    NO_INGREDIENTS_SELECTED: 'Ingen ingredienser valgt ennå.',
    FAILED_LOAD_INGREDIENTS: 'Kunne ikke laste ingredienser. Prøv igjen.',
    FAILED_CREATE_INGREDIENT: 'Kunne ikke opprette ingrediens. Prøv igjen.',
    CONFIRM_DELETE_INGREDIENT: 'Er du sikker på at du vil slette denne ingrediensen permanent fra biblioteket?',
    DELETE_INGREDIENT: 'Slett ingrediens',
    INGREDIENT_DELETED_LIBRARY: 'Ingrediens slettet fra biblioteket.',
    FAILED_DELETE_INGREDIENT: 'Kunne ikke slette ingrediens. Prøv igjen.',
    WITHOUT: 'Uten',
    CATERING_ADDON_ERR_DELIVERY_METHOD_REQUIRED: 'Minst én leveringsmetode må velges.',
    CATERING_ADDON_ERR_PRICE_NEGATIVE: 'Pris for tilvalg kan ikke være negativ.',
    NO_DATA: 'Ingen data tilgjengelig',
    NO_DATA_HINT: 'Det er ingenting å vise akkurat nå.',

    // Catering: no-login order-by-invoice checkout
    GUEST_INVOICE_ORDERING: "Gjestebestilling mot faktura",
    GUEST_INVOICE_ORDERING_DESC: "Aktiverer bestilling mot faktura uten innlogging for denne restauranten. Gjesten oppgir firma- og faktureringsopplysninger i kassen i stedet for å betale.",
    CATERING_SHOW_PRICES_EX_VAT: "Vis priser ekskl. mva. (B2B)",
    CATERING_SHOW_PRICES_EX_VAT_DESC: "Viser cateringpriser ekskl. mva. i nettbutikken, med mva. og total inkl. mva. i kassen. Kun visning: beløpet som belastes endres ikke.",
    // --- Order validation devices ---------------------------------------------
    ORDER_VALIDATION_MENU: 'Ordrevalidering',
    ORDER_VALIDATION_DEVICES: 'Enheter',
    ORDER_VALIDATION_DEVICES_SUBTITLE: 'QR-terminalene der gjester skanner ordren sin. Endringer her slår gjennom på terminalen av seg selv.',
    ORDER_VALIDATION_DEVICES_TABLE_TITLE: 'Terminaler',
    ORDER_VALIDATION_DEVICES_ADD: 'Legg til terminal',
    ORDER_VALIDATION_DEVICES_CREATE: 'Opprett',
    ORDER_VALIDATION_DEVICES_EDIT: 'Terminalinnstillinger',
    ORDER_VALIDATION_DEVICES_NAME: 'Navn',
    ORDER_VALIDATION_DEVICES_NAME_PLACEHOLDER: 'f.eks. Inngangsterminal',
    ORDER_VALIDATION_DEVICES_NAME_REQUIRED: 'Gi terminalen et navn',
    ORDER_VALIDATION_DEVICES_ID: 'Enhets-ID',
    ORDER_VALIDATION_DEVICES_ROUTE: 'Restaurant',
    ORDER_VALIDATION_DEVICES_ROUTE_HELP: 'Enheten terminalen validerer for. Ordrer fra andre steder avvises.',
    ORDER_VALIDATION_DEVICES_ROUTE_REQUIRED: 'Velg en restaurant',
    ORDER_VALIDATION_DEVICES_LANGUAGE: 'Språk',
    ORDER_VALIDATION_DEVICES_LANGUAGE_UNSET: 'La terminalen bestemme',
    ORDER_VALIDATION_DEVICES_LANGUAGE_HELP: 'Står det tomt beholder terminalen språket som er valgt på den.',
    ORDER_VALIDATION_DEVICES_SOUNDS: 'Lyd',
    ORDER_VALIDATION_DEVICES_SOUND_SUCCESS: 'Lyd ved godkjent skanning',
    ORDER_VALIDATION_DEVICES_SOUND_FAILURE: 'Lyd ved avvist skanning',
    ORDER_VALIDATION_DEVICES_VERSION: 'Versjon',
    ORDER_VALIDATION_DEVICES_LAST_SEEN: 'Sist sett',
    ORDER_VALIDATION_DEVICES_ONLINE: 'Online',
    ORDER_VALIDATION_DEVICES_EMPTY: 'Ingen terminaler ennå. Legg til en, og skriv inn ID-en på terminalen.',
    ORDER_VALIDATION_DEVICES_CREATED_HELP: 'Skriv inn denne ID-en på terminalen, under PubQ-logoen, for å koble den til.',
    ORDER_VALIDATION_DEVICES_ID_COPIED: 'Enhets-ID kopiert',
    ORDER_VALIDATION_DEVICES_CREATE_FAILED: 'Kunne ikke opprette terminalen',
    ORDER_VALIDATION_DEVICES_SAVED: 'Terminalinnstillinger lagret',
    ORDER_VALIDATION_DEVICES_SAVE_ERROR: 'Kunne ikke lagre terminalinnstillingene',
    ORDER_VALIDATION_DEVICES_LOAD_ERROR: 'Kunne ikke hente terminalene',
    ORDER_VALIDATION_DEVICES_REMOVE: 'Fjern',
    ORDER_VALIDATION_DEVICES_REMOVE_CONFIRM: 'Fjerne terminalen fra enheten?',
    ORDER_VALIDATION_DEVICES_REMOVE_WARNING: 'Terminalen fortsetter å validere med innstillingene den allerede har. Å fjerne den her tar den bare ut av listen.',
    ORDER_VALIDATION_DEVICES_REMOVED: 'Terminalen fjernet',
    ORDER_VALIDATION_DEVICES_REMOVE_FAILED: 'Kunne ikke fjerne terminalen',
    // Sidebar labels for the POS section (the screens keep their own titles)
    NAV_POS_BUTTON_LAYER: 'POS-knappelag',
    NAV_POS_DEVICES: 'Enheter',
    NAV_POS_ACTIVITY_LOG: 'Aktivitetslogg',
    POS_SETTINGS: 'Innstillinger',
    POS_SETTINGS_SUBTITLE: 'Konfigurer POS-innstillinger for denne enheten.',
    POS_QUICK_RAIL: 'Hurtigmeny',
    POS_QUICK_RAIL_SUBTITLE: 'Konfigurer knappen for åpne produkter som vises ved siden av handlekurven i POS V2.',
    POS_QUICK_RAIL_OPEN_PRODUCTS_ENABLED: 'Aktiver åpne produkter',
    POS_QUICK_RAIL_OPEN_PRODUCTS_ENABLED_HINT: 'Vis knappen for åpne produkter i hurtigmenyen i kassen.',
    POS_QUICK_RAIL_OPEN_PRODUCTS: 'Åpne produkter',
    POS_QUICK_RAIL_OPEN_PRODUCTS_HINT: 'Velg produkter fra produktkatalogen som personalet kan prise manuelt.',
    POS_QUICK_RAIL_OPEN_PRODUCTS_EMPTY: 'Ingen åpne produkter valgt ennå. Legg til produkter ovenfor.',
    POS_QUICK_RAIL_ADD_PRODUCTS: 'Legg til produkter',
    POS_QUICK_RAIL_DELETE_CONFIRM: 'Er du sikker på at du vil fjerne "{name}"?',
    POS_QUICK_RAIL_SAVED: 'Hurtigmeny-innstillinger lagret.',
    POS_QUICK_RAIL_SAVE_ERROR: 'Kunne ikke lagre hurtigmeny-innstillinger. Prøv igjen.',
    POS_QUICK_RAIL_LOAD_ERROR: 'Kunne ikke laste inn hurtigmeny-innstillinger. Prøv igjen.',
    // Integrations + Fortnox (Z): MACHINE-TRANSLATED from Swedish, needs native-Norwegian review (language.dk-no.REVIEW.md)
    INTEG_TITLE: "Integrasjoner",
    INTEG_OVERVIEW: "Oversikt",
    INTEG_THIS_RESTAURANT: "restauranten",
    INTEG_LOADING_STATUS: "Henter status…",
    INTEG_COMING_SOON: "Kommer snart",
    INTEG_REAUTH: "Koblingen må godkjennes på nytt",
    INTEG_NOT_CONNECTED: "Ikke koblet til",
    INTEG_NO_ACCESS: "Ingen tilgang",
    INTEG_MANAGE: "Administrer",
    INTEG_ACTIVATE: "Aktiver",
    INTEG_DESC_FORTNOX: "Bokfører hver lukket Z-rapport som et bilag i selskapets Fortnox. Kostnadssted og kontotilordning per restaurant.",
    INTEG_DESC_PERSONALKOLLEN: "Vaktplanlegging og timeføring: ansatte, vakter og lønnskostnader synkroniseres med PubQ.",
    INTEG_DESC_TCPOS: "Salgseksport til TCPOS (SOAP / REST) for kjeder som rapporterer i TCPOS.",
    FZ_TITLE: "Fortnox – Z-rapporter",
    FZ_INTRO: "Hver lukket Z-rapport kan bokføres som et bilag i selskapets Fortnox.",
    FZ_MODE_MOCK: "TESTMODUS (mock): ingenting sendes til Fortnox, bilagsnumre er oppdiktet.",
    FZ_MODE_READONLY: "LESEMODUS: koblingen og kontrollene mot Fortnox fungerer, men ingen bilag opprettes.",
    FZ_NO_UNIT: "Ingen restaurant er valgt. Velg en restaurant i menyen.",
    FZ_NOTICE_CONNECTED: "Fortnox er koblet til for selskapet.",
    FZ_CONNECTION_HEADER: "Kobling (selskapet)",
    FZ_RETRY: "Prøv igjen",
    FZ_CONNECTED_TO: "Koblet til",
    FZ_DISCONNECT_COMPANY: "Koble fra selskapet…",
    FZ_BELONGS_TO: "Restauranten tilhører",
    FZ_ORG_MISSING: "org.nr. mangler",
    FZ_CONNECT_HELP: "Du logger inn i selskapets Fortnox som administrator og godkjenner. Fortnox-kontoen må ha samme organisasjonsnummer.",
    FZ_CONNECT: "Koble til Fortnox",
    FZ_DISCONNECTED_OK: "Fortnox koblet fra for selskapet",
    FZ_LISTS_STILL_SAVE: "du kan fortsatt lagre innstillingene.",
    FZ_AUTO_EXPORT: "Automatisk eksport",
    FZ_COST_CENTER: "Kostnadssted",
    FZ_NONE: "– ingen –",
    FZ_LOADING_COST_CENTERS: "Henter kostnadssteder…",
    FZ_NO_COSTCENTER_SCOPE: "Koblingen mangler tillatelsen \"kostnadssteder\" – Fortnox kontrollerer koden ved bokføring.",
    FZ_VOUCHER_SERIES: "Bilagsserie",
    FZ_COMPANY_DEFAULT: "– selskapets standard –",
    FZ_ROUNDING_ACCOUNT: "Konto for øreavrunding",
    FZ_REVIEW_FIRST: "Gjennomgå de første manuelt",
    FZ_ACCOUNT_MAPPING: "Kontotilordning",
    FZ_ACCOUNT_MAPPING_HELP: "Bytter en konto fra kassen mot en annen konto i Fortnox (eller \"drop\" for linjer uten beløp).",
    FZ_POS_ACCOUNT: "Kassens konto",
    FZ_FORTNOX_ACCOUNT: "Fortnox-konto",
    FZ_ADD_MAPPING: "Legg til tilordning",
    FZ_SAVE: "Lagre",
    FZ_SETTINGS_SAVED: "Innstillingene ble lagret",
    FZ_ZREPORTS: "Z-rapporter",
    FZ_COL_BUSINESS_DATE: "Forretningsdag",
    FZ_COL_TOTAL: "Totalt",
    FZ_COL_STATUS: "Status",
    FZ_TEST: "test",
    FZ_STATUS_NOT_SENT: "Ikke sendt",
    FZ_STATUS_PENDING: "I kø",
    FZ_STATUS_HELD: "Venter på gjennomgang",
    FZ_STATUS_SENDING: "Sendes",
    FZ_STATUS_SENT: "Sendt",
    FZ_STATUS_FAILED: "Mislyktes",
    FZ_STATUS_LEGACY: "Bokført (gammel flyt)",
    FZ_PREVIEW: "Forhåndsvis",
    FZ_APPROVE_SEND: "Godkjenn og send",
    FZ_SEND: "Send",
    FZ_RESEND_ELLIPSIS: "Send på nytt…",
    FZ_EMPTY: "Ingen lukkede Z-rapporter ennå.",
    FZ_BACKFILL_LABEL: "Ettersend Z",
    FZ_FROM: "fra",
    FZ_TO: "til",
    FZ_BACKFILL: "Ettersend",
    FZ_BACKFILL_HELP: "Eldste først. Allerede bokførte hoppes over. Stopper ved første feil.",
    FZ_NOT_SENT_BECAUSE: "Sendes ikke:",
    FZ_COL_ACCOUNT: "Konto",
    FZ_COL_TEXT: "Tekst",
    FZ_COL_DEBIT: "Debet",
    FZ_COL_CREDIT: "Kredit",
    FZ_COL_COST_CENTER_SHORT: "KS",
    FZ_SUM: "Sum",
    FZ_CLOSE: "Lukk",
    FZ_RESEND_SECOND: "Å sende på nytt oppretter et nytt bilag for samme dag.",
    FZ_RESEND_VOID_HINT: "Annuller det første i Fortnox hvis det er feil.",
    FZ_TYPE_TO_CONFIRM: "Skriv følgende for å bekrefte:",
    FZ_TYPE_ORGNO_TO_CONFIRM: "Skriv organisasjonsnummeret for å bekrefte:",
    FZ_CANCEL: "Avbryt",
    FZ_RESEND: "Send på nytt",
    FZ_DISCONNECT_TITLE: "Koble fra Fortnox?",
    FZ_DISCONNECT_EFFECT: "Automatisk eksport slutter å virke til noen kobler til på nytt.",
    FZ_DISCONNECT: "Koble fra",
    FZ_ERROR: "Feil",
    FZ_REFUSED_ALREADY_SENT: "allerede bokført",
    FZ_REFUSED_IN_PROGRESS: "sendes allerede",
    FZ_REFUSED_HELD: "venter på gjennomgang",
    FZ_TOAST_MOCK: "TEST – mock",
    FZ_ERR_FORBIDDEN: "Du har ikke tilgang til denne restauranten.",
    FZ_ERR_LOAD: "Kunne ikke hentes",
    FZ_ERR_CONNECTION: "Koblingen kunne ikke hentes",
    FZ_ERR_LISTS: "Kontoer og kostnadssteder kunne ikke hentes fra Fortnox",
    FZ_ERR_ZLIST: "Z-rapportene kunne ikke hentes",
    FZ_ERR_NOT_SIGNED_IN: "Du er ikke logget inn.",
    FZ_ERR_SERVICE_TIMEOUT: "Fortnox-tjenesten svarte ikke i tide",
    FZ_ERR_UNREACHABLE: "Kunne ikke nå Fortnox-tjenesten (nettverk eller CORS)",
    // Status page (third-party service status)
    MENU_NAV_STATUS: "Systemstatus",
    MENU_SECTION_OVERVIEW: "Oversikt",
    MENU_SECTION_MENU: "Meny og produkter",
    MENU_SECTION_CHANNELS: "Salgskanaler",
    MENU_SECTION_GUESTS: "Markedsføring",
    MENU_SECTION_ECONOMY: "Økonomi",
    MENU_SECTION_ADMIN: "Administrasjon",
    MENU_SEARCH_PLACEHOLDER: "Søk i menyen",
    MENU_SEARCH_EMPTY: "Ingen sider samsvarer",
    STATUS_PAGE_TITLE: "Systemstatus",
    STATUS_PAGE_SUBTITLE: "Status for tredjepartstjenestene enheten deres bruker",
    PROVIDER_REFRESH: "Oppdater",
    PROVIDER_SECTION_TITLE: "Tredjepartstjenester",
    PROVIDER_ISSUES_COUNT: "Tjenester med problemer",
    PROVIDER_ALL_OPERATIONAL: "Alle tjenester er i drift",
    PROVIDER_LAST_UPDATED: "Oppdatert",
    PROVIDER_STATUS_PAGE: "Statusside",
    PROVIDER_FETCH_FAILED: "Kunne ikke hente status",
    PROVIDER_LOADING: "Henter…",
    PROVIDER_EVENTS_TITLE: "Hendelser",
    PROVIDER_NO_EVENTS: "Ingen pågående, planlagte eller nylig løste hendelser.",
    PROVIDER_PER_PAGE: "Per side:",
    PROVIDER_LEVEL_OPERATIONAL: "I drift",
    PROVIDER_LEVEL_MAINTENANCE: "Vedlikehold",
    PROVIDER_LEVEL_DEGRADED: "Redusert",
    PROVIDER_LEVEL_PARTIAL_OUTAGE: "Delvis brudd",
    PROVIDER_LEVEL_MAJOR_OUTAGE: "Større brudd",
    PROVIDER_LEVEL_UNKNOWN: "Ukjent",
    PROVIDER_EVENT_RESOLVED: "Løst",
    PROVIDER_EVENT_SCHEDULED_MAINTENANCE: "Planlagt vedlikehold",
    PROVIDER_EVENT_ONGOING_MAINTENANCE: "Pågående vedlikehold",
    PROVIDER_EVENT_ONGOING_INCIDENT: "Pågående driftsforstyrrelse",


    // --- Organisasjon: gruppens tall, delt katalog, delte tilbud -------------
    ORG_MENU: "Organisasjon",
    ORG_ORGANISATION: "Organisasjon",
    ORG_DASHBOARD: "Oversikt",
    ORG_DASHBOARD_SUBTITLE: "Salg for hele gruppen, og per enhet.",
    ORG_CATALOG: "Delt produktkatalog",
    ORG_CATALOG_SUBTITLE: "Produkter gruppen deler. Publisering skriver til hver enhets egen meny.",
    ORG_CATALOG_HOW_IT_WORKS: "En publisering skriver produktet til hver valgt enhets egen meny — derfor journalfører hver kasse sin egen prisendring. Enheter med eget låst pris hoppes over.",
    ORG_COUPONS: "Delte tilbud",
    ORG_COUPONS_SUBTITLE: "Kuponger og tilbud gruppen deler med sine enheter.",
    ORG_COUPONS_HOW_IT_WORKS: "Definer tilbudet sentralt og del det med enhetene som skal ha det. En enhet kan ha sin egen verdi.",
    ORG_ACCESS: "Organisasjonstilgang",
    ORG_ACCESS_SUBTITLE: "Hvem som ser gruppens tall, og hvem som får administrere dem.",
    ORG_ACCESS_WARNING: "Medlemskap i en organisasjon gir ikke tilgang til gruppens salg. Bare en uttrykkelig rolle her gjør det — 841 brukere har allerede en organisasjonsrad, og de skal ikke se kjedens tall ved en feil.",
    ORG_UNITS: "enheter",
    ORG_UNIT: "Enhet",
    ORG_COMPANIES: "selskaper",
    ORG_PERIOD: "Periode",
    ORG_TOTAL_SALES: "Salg",
    ORG_SALES: "Salg",
    ORG_RECEIPTS: "kvitteringer",
    ORG_AVG_RECEIPT: "Snittkvittering",
    ORG_SALES_PER_DAY: "Salg per dag",
    ORG_SALES_PER_HOUR: "Salg per time",
    ORG_PER_UNIT: "Per enhet",
    ORG_PAYMENTS: "Betalingsmåter",
    ORG_PAYMENT_METHOD: "Betalingsmåte",
    ORG_TOP_PRODUCTS: "Mest solgte produkter",
    ORG_PRODUCT: "Produkt",
    ORG_CATEGORY: "Kategori",
    ORG_QUANTITY: "Antall",
    ORG_AMOUNT: "Beløp",
    ORG_COUNT: "Antall",
    ORG_SHARE: "Andel",
    ORG_TOTAL: "Totalt",
    ORG_NO_DATA: "Ingen data for perioden.",
    ORG_NO_UNITS: "Ingen enheter i denne organisasjonen.",
    ORG_MULTI_CURRENCY: "Gruppen har enheter i flere valutaer. Summene vises per valuta — de legges aldri sammen.",
    ORG_UNITS_TRUNCATED: "Flere enheter enn ett kall rommer. Disse er ikke med:",
    ORG_STATS_UNAVAILABLE: "Statistikktjenesten er ikke slått på i dette miljøet.",
    ORG_STATS_FAILED: "Statistikken kunne ikke hentes.",
    ORG_LOAD_FAILED: "Kunne ikke hentes.",
    ORG_SAVE_FAILED: "Kunne ikke lagres.",
    ORG_ERROR: "Feil",
    ORG_SAVED: "Lagret",
    ORG_UNITS_SAVED: "Enhetene ble lagret",
    ORG_DEMO_DATA: "DEMODATA",
    ORG_DEMO_DATA_HELP: "Endepunktet finnes ikke ennå. Det som vises er oppdiktet og lagres ikke.",
    ORG_DEMO_NOT_SAVED: "Demodata — ingenting ble lagret.",
    ORG_LIVE_DATA: "Live data",
    ORG_DERIVED_UNITS: "Egne enheter",
    ORG_DERIVED_UNITS_HELP: "Enhetene er de du selv er tildelt, gruppert per organisasjon. Serverens egen enhetsliste er ikke klar, så en gruppe kan vise for få enheter.",
    ORG_NEW_PRODUCT: "Nytt produkt",
    ORG_EDIT_PRODUCT: "Rediger produkt",
    ORG_NO_PRODUCTS: "Ingen produkter i katalogen ennå.",
    ORG_NAME: "Navn",
    ORG_DESCRIPTION: "Beskrivelse",
    ORG_BASE_PRICE: "Pris",
    ORG_BASE_PRICE_ORE: "Pris (øre)",
    ORG_VAT: "MVA",
    ORG_SALES_ACCOUNT: "Salgskonto",
    ORG_ACTIVE: "Aktiv",
    ORG_INACTIVE: "Inaktiv",
    ORG_ASSIGNED_UNITS: "Enheter",
    ORG_VERSION: "Versjon",
    ORG_EDIT: "Rediger",
    ORG_ASSIGN_UNITS: "Velg enheter",
    ORG_SHARE_WITH_UNITS: "Del med enheter",
    ORG_PUBLISH: "Publiser",
    ORG_PUBLISH_NOW: "Publiser nå",
    ORG_PUBLISHED: "Publisert",
    ORG_UNITS_QUEUED: "enheter i kø",
    ORG_PUBLISH_FAILED: "Publiseringen mislyktes.",
    ORG_PREVIEW_FAILED: "Forhåndsvisningen kunne ikke hentes.",
    ORG_ON: "På",
    ORG_PRICE_OVERRIDE: "Eget pris (øre)",
    ORG_VALUE_OVERRIDE: "Egen verdi",
    ORG_ORG_PRICE: "Gruppens pris",
    ORG_ORG_VALUE: "Gruppens verdi",
    ORG_CLEAR_OVERRIDE: "Fjern egen verdi",
    ORG_WONT_BE_PUBLISHED: "Overskrives ikke",
    ORG_PUBLISHED_LABEL: "Publisert",
    ORG_OVERRIDE_HELP: "En enhets eget pris overskrives aldri av en publisering. Fjern det hvis enheten skal følge gruppens pris igjen.",
    ORG_COUPON_OVERRIDE_HELP: "En enhets egen verdi gjelder foran gruppens.",
    ORG_EDIT_NOT_PUBLISHED: "Å lagre endrer katalogen. Enhetene får endringen først når du publiserer.",
    ORG_WILL_UPDATE: "Oppdateres",
    ORG_WILL_SKIP: "Hoppes over",
    ORG_PUBLISH_JOURNAL_NOTE: "Hver oppdatert enhet journalfører sin egen prisendring. Antall journalposter:",
    ORG_PUBLISH_BLOCKED_REGISTER: "Publiseringen er stoppet: kassaapparat kunne ikke finnes for alle enheter, og prisendringen ville da gå gjennom uten journalpost. Antall enheter:",
    ORG_PUBLISH_NOTHING: "Ingenting å publisere — alle enheter er oppdaterte.",
    ORG_COUPON: "Tilbud",
    ORG_NEW_COUPON: "Nytt tilbud",
    ORG_EDIT_COUPON: "Rediger tilbud",
    ORG_NO_COUPONS: "Ingen tilbud ennå.",
    ORG_CODE: "Kode",
    ORG_VALUE: "Verdi",
    ORG_VALID: "Gjelder",
    ORG_VALID_FROM: "Gjelder fra",
    ORG_VALID_TO: "Gjelder til",
    ORG_COUPON_KIND: "Type",
    ORG_COUPON_PERCENTAGE: "Prosent",
    ORG_COUPON_AMOUNT: "Beløp",
    ORG_COUPON_FREE_ITEM: "Gratis vare",
    ORG_COUPON_PCT_HELP: "0–100",
    ORG_GRANT_ACCESS: "Gi tilgang",
    ORG_GRANT: "Gi tilgang",
    ORG_REVOKE: "Fjern tilgang",
    ORG_REVOKE_CONFIRM: "Fjern organisasjonstilgang for",
    ORG_ACCESS_GRANTED: "Tilgang gitt",
    ORG_ACCESS_REVOKED: "Tilgang fjernet",
    ORG_USER: "Bruker",
    ORG_ROLE: "Rolle",
    ORG_GRANTED: "Gitt",
    ORG_EMAIL: "E-post",
    ORG_ROLE_ADMIN: "Organisasjonsadmin",
    ORG_ROLE_VIEWER: "Leser",
    ORG_ROLE_ADMIN_HELP: "ser gruppens salg og administrerer katalogen, tilbudene og hvem som har tilgang.",
    ORG_ROLE_VIEWER_HELP: "ser gruppens salg. Ingenting annet.",
    ORG_ROLES_EXPLAINED: "Hva rollene betyr",
    ORG_ADMIN_ONLY: "Bare en organisasjonsadmin kan endre dette.",
    ORG_NO_ACCESS_ROWS: "Ingen har organisasjonstilgang ennå.",
    ORG_GRANT_EMAIL_HELP: "Brukeren må allerede finnes i PubQ.",
    ORG_GRANT_ADMIN_WARNING: "En organisasjonsadmin ser hele gruppens salg og kan gi andre samme tilgang.",

    ORG_STAFF_ACCESS: "PubQ-personale",
    ORG_STAFF_ACCESS_HELP: "Du er logget inn som PubQ-personale og kan åpne enhver organisasjon.",
    ORG_API_PROBLEM: "API-problem",
    ORG_API_NOT_DEPLOYED: "Organisasjons-API-et er ikke rullet ut i dette miljøet.",
    ORG_FORBIDDEN: "Du har ikke organisasjonstilgang til denne organisasjonen.",
    ORG_NET: "Netto",
    ORG_NO_SALES: "Ingen salg",
    ORG_OTHER_TYPES: "Andre kvitteringer",
    ORG_OTHER_TYPES_HELP: "Kvitteringer som ikke er salg (returer, proforma). Rapporteres separat og regnes aldri med i salget.",
    ORG_SOLD_IN_UNITS: "Enheter",
    ORG_SHOW_ARCHIVED: "Vis arkiverte",
    ORG_ARCHIVED_TAG: "Arkivert",
    ORG_ARCHIVE: "Arkiver",
    ORG_ARCHIVED: "Arkivert",
    ORG_ARCHIVE_PUBLISH_NOTE: "Arkivert i katalogen. Publiser for å fjerne den fra enhetene.",
    ORG_PRODUCT_TYPE: "Produkttype",
    ORG_CONTAINS_ALCOHOL: "Inneholder alkohol",
    ORG_VAT_ACCOUNT_HINT: "Salgskonto (hint)",
    ORG_VAT_ACCOUNT_HINT_HELP: "Enheter har ofte flere kontoer for samme MVA-sats (12 % mat og 12 % mineralvann). Uten hint eller enhetsvalg nekter publiseringen å gjette.",
    ORG_SELLABLE: "Salgbar",
    ORG_SELLABLE_HELP: "Av betyr at varen finnes i enheten men ikke selges. Den fjernes aldri.",
    ORG_STALE: "Ikke oppdatert",
    ORG_UNITS_IN_SCOPE: "enheter i omfanget",
    ORG_UNCHANGED: "uendrede",
    ORG_WOULD_WITHDRAW: "fjernes",
    ORG_WOULD_FAIL: "mislykkes",
    ORG_WARNINGS: "advarsler",
    ORG_PUBLISH_SOME_FAIL: "Noen enheter ville mislykkes. Publiseringen kjører for de øvrige — rett disse og publiser igjen.",
    ORG_PUBLISH_QUEUED: "Publisering i kø",
    ORG_RUN: "Kjøring",
    ORG_RUN_SWEEP: "hentes innen 15 min",
    ORG_ENABLED: "På",
    ORG_DISCOUNT: "Rabatt",
    ORG_DISCOUNT_HELP: "1–100 %. Bare prosent støttes i appene.",
    ORG_OFFER_KIND_CODE: "Rabattkode",
    ORG_OFFER_KIND_OFFER: "Tilbud",
    ORG_CODE_HELP: "A–Z, 0–9, _ og -. 3–50 tegn. Unik blant organisasjonens aktive koder.",
    ORG_CODE_CONFLICT: "Koden brukes allerede av et aktivt tilbud i organisasjonen.",
    ORG_KIND_LOCKED: "Typen kan ikke endres etterpå.",
    ORG_LIVE_UNITS: "Live",
    ORG_LIVE_NOW: "Live nå",
    ORG_WITHDRAWN: "Fjernet",
    ORG_VALIDITY_ENFORCED: "Gyldighetsperioden styrer publiseringen: utenfor den fjernes koden i hver enhet, og legges tilbake innen cirka 15 minutter.",
    ORG_OFFER_CONFLICT_NOTE: "En enhet som allerede har sin egen kode med samme tekst får ikke organisasjonens kode. Enhetens egen kode endres aldri.",
    ORG_UNIT_FLAG_NOTE: "Advarsler: apper viser koder bare hvis enheten har kupongkoder slått på, og tilbud bare hvis globale tilbud er slått på. Publiseringen endrer ikke enhetens innstillinger.",
    ORG_STAFF_ONLY: "Bare PubQ-personale kan endre dette.",
    ORG_STAFF_ONLY_NOTE: "Du kan se hvem som har tilgang. Å gi eller fjerne tilgang gjøres av PubQ-personale — en organisasjonsadmin kan ikke forfremme andre.",
    ORG_ROLE_STAFF: "PubQ-personale",
    ORG_ROLE_STAFF_HELP: "ser alt, og er de eneste som kan gi eller fjerne organisasjonstilgang.",
    ORG_ACCESS_ALREADY: "Tilgang fantes allerede",
    ORG_USER_NOT_FOUND: "Det finnes ingen PubQ-konto med den e-posten. En tilgang oppretter aldri en konto.",
    ORG_AUDIT: "Historikk",
    ORG_NO_AUDIT: "Ingen historikk.",
    ORG_REASON: "Årsak",
    ORG_REASON_HELP: "Lagres i historikken.",
    ORG_WHEN: "Når",
    ORG_ACTION: "Handling",
    ORG_BY: "Av",

    ORG_MANAGED_TAG: "Organisasjon",
    ORG_MANAGED_HELP: "Styres av organisasjonen. Den ble lagt hit av en organisasjonspublisering, ikke opprettet i denne enheten.",
    ORG_MANAGED_EDIT_WARNING: "Du kan endre denne varen, men neste publisering fra organisasjonen overskriver feltene organisasjonen eier. Hvis enheten trenger sin egen pris permanent, be organisasjonen om å sette et unntak for enheten.",

    ORG_EXTERNAL_ID: "Eksternt ID",
    ORG_EXTERNAL_ID_HELP: "Varens ID i et annet system, f.eks. Compass Groups TCPOS-artikkelnummer. Sendes til hver enhet og er feltet TCPOS-eksporten leser. Tøm feltet for å fjerne det.",
    ORG_EXTERNAL_ID_KEY: "System",
    ORG_EXTERNAL_ID_OVERRIDE: "Eksternt ID for enheten",
    ORG_WRITTEN: "skrevet",
    ORG_FAILED: "mislyktes",
    ORG_RETRY: "Prøv igjen",
    ORG_PUBLISH_DONE: "Publisering ferdig",
    ORG_PUBLISH_PARTIAL: "Publisering ferdig med feil",
    ORG_RUN_STILL_GOING: "Kjøringen pågår fortsatt. Den fortsetter i bakgrunnen — last inn på nytt senere for å se resultatet.",

    ORG_IMAGE: "Bilde",
    ORG_IMAGE_CHOOSE: "Velg bilde",
    ORG_IMAGE_REPLACE: "Bytt bilde",
    ORG_IMAGE_CLEAR: "Fjern",
    ORG_IMAGE_HELP: "Lastes opp som organisasjonens eget bilde (org/{id}/products/) og publiseres til hver enhet sammen med varen.",

    ORG_IMAGE_NOT_AN_IMAGE: "Filen er ikke et bilde.",
    ORG_IMAGE_UPLOAD_FAILED: "Bildet kunne ikke lastes opp.",
    ORG_IMAGE_DENIED: "Lagringsreglene nektet skrivingen til organisasjonens sti. Be PubQ legge til regelen for:",

    // --- Send faktura til Fortnox (utkast; aldri bokført fra PubQ) ---------
    FZ_INV_COLUMN: "Fortnox",
    FZ_INV_SEND: "Send til Fortnox",
    FZ_INV_RETRY: "Prøv igjen",
    FZ_INV_RESEND: "Send igjen",
    FZ_INV_SENDING: "Sender…",
    FZ_INV_FAILED: "Mislyktes",
    FZ_INV_UNCERTAIN: "Usikker",
    FZ_INV_NOT_SENT: "Ikke sendt",
    FZ_INV_NOT_SENT_YET: "Fakturaen er ikke sendt til Fortnox.",
    FZ_INV_DOC: "Fortnox-faktura",
    FZ_INV_DRAFT_NOTE: "opprettet som ubokført utkast. Bokfør og send den i Fortnox.",
    FZ_INV_SENT_TITLE: "Sendt til Fortnox",
    FZ_INV_ALREADY_TITLE: "Finnes allerede i Fortnox",
    FZ_INV_FAILED_TITLE: "Fortnox avviste fakturaen",
    FZ_INV_NOT_READY: "Fakturaen kan ikke sendes til Fortnox ennå.",
    FZ_INV_CONFIRM: "Dette oppretter en ny ubokført faktura i Fortnox. PubQ bokfører den ikke og sender den ikke til kunden.",
    FZ_INV_CONFIRM_DRIFT: "Fortnox summerer fakturaen litt annerledes — kontrollér den der.",
    FZ_INV_LINK_CUSTOMER_FIRST: "Koble kunden til Fortnox først",
    FZ_INV_GO_LINK_CUSTOMER: "Gå til bedriftskunder",
    FZ_INV_RECONNECT: "Koble til Fortnox igjen for å kunne fakturere",
    FZ_INV_RECONNECT_CTA: "Koble til Fortnox igjen",
    FZ_INV_DISABLED: "Fakturering til Fortnox er ikke aktivert i dette miljøet",
    FZ_INV_NOT_CONNECTED: "Restauranten er ikke koblet til Fortnox",
    FZ_INV_IN_PROGRESS: "Fakturaen sendes akkurat nå",
    FZ_INV_UNCERTAIN_HELP: "En tidligere sending kan allerede ha opprettet fakturaen i Fortnox. Kontrollér i Fortnox før du sender igjen.",
    FZ_INV_RESEND_TITLE: "Send fakturaen igjen?",
    FZ_INV_RESEND_CONFIRM_LABEL: "Skriv bekreftelsen for å sende igjen:",
    FZ_INV_RECONCILE: "Sum i PubQ / i Fortnox",

    // --- Kundeimport fra Fortnox (regnskapssystemet som kilde) --------------
    FZ_CUST_SEARCH_LABEL: "Søk kunde i Fortnox",
    FZ_CUST_SEARCH_PLACEHOLDER: "Navn, kundenummer eller organisasjonsnummer",
    FZ_CUST_SEARCH_HINT: "Skriv minst to tegn. Søker blant kundene i det tilkoblede Fortnox-selskapet.",
    FZ_CUST_INCLUDE_INACTIVE: "Vis også inaktive",
    FZ_CUST_INACTIVE: "inaktiv",
    FZ_CUST_NO_RESULTS: "Ingen kunde i Fortnox passer med søket.",
    FZ_CUST_OR_MANUAL: "eller fyll inn opplysningene selv",
    FZ_CUST_PREFILLED_FROM: "Forhåndsutfylt fra Fortnox:",
    FZ_CUST_DISCARD_PICK: "Fjern",
    FZ_CUST_REVIEW_HELP: "Se gjennom og juster opplysningene før du lagrer. Ingenting skrives til Fortnox — PubQ leser bare kunderegisteret.",
    FZ_CUST_REVIEW_TERMS: "Betalingsbetingelsen i Fortnox er ikke et antall dager. 30 dager er fylt inn — kontrollér det.",
    FZ_CUST_REVIEW_EMAIL: "Kunden har ingen e-postadresse i Fortnox. Fyll inn fakturamottaker selv.",
    FZ_CUST_REVIEW_ORGNO: "Kunden har ikke organisasjonsnummer i Fortnox. Fyll det inn selv.",
    FZ_CUST_WILL_CREATE: "Lagres som en ny bedriftskunde.",
    FZ_CUST_WILL_LINK: "Organisasjonsnummeret finnes allerede som bedriftskunde. Den kobles til Fortnox-kunden; dine egne opplysninger blir ikke rørt.",
    FZ_CUST_ALREADY_TITLE: "Allerede importert",
    FZ_CUST_ALREADY_HELP: "Denne Fortnox-kunden er allerede importert. Åpne den eksisterende kunden, eller bruk Oppdater fra Fortnox på den.",
    FZ_CUST_OPEN_EXISTING: "Åpne eksisterende kunde",
    FZ_CUST_CONFLICT_TITLE: "Flere mulige treff",
    FZ_CUST_CONFLICT_HELP: "Det finnes en bedriftskunde som kan være samme selskap, men treffet er for svakt til å koble automatisk. Velg å koble til en av dem, eller å opprette en ny kunde.",
    FZ_CUST_MATCHED_ON: "Treff på",
    FZ_CUST_LINK_THIS: "Koble til denne",
    FZ_CUST_CREATE_ANYWAY: "Opprett ny kunde likevel",
    FZ_CUST_CHOOSE_FIRST: "Velg koble eller opprett ny før du lagrer.",
    FZ_CUST_IMPORTED: "Bedriftskunden ble importert fra Fortnox.",
    FZ_CUST_LINKED: "Bedriftskunden ble koblet til Fortnox-kunden.",
    FZ_CUST_SOURCE_TAG: "Fortnox",
    FZ_CUST_REFRESH: "Oppdater fra Fortnox",
    FZ_CUST_REFRESH_NO_CHANGE: "Alt var allerede i takt med Fortnox.",
    FZ_CUST_RECONNECT_TITLE: "Kundeimport er ikke aktivert",
    FZ_CUST_RECONNECT_CTA: "Koble til Fortnox igjen for å aktivere kundeimport",
    FZ_CUST_CONSENT_NOTE: "Tilkoblingen gir også PubQ leserett til kunderegisteret ditt i Fortnox, slik at du kan importere kunder. PubQ endrer aldri noe der.",
}

